{
    "defaults": {
        "validation": {
            "scriptElementNotAllowed": "Der Text enthält ein <script>-Element. Bitte entfernen Sie es – solange es enthalten ist, kann nicht gespeichert werden.",
            "scriptUrlNotAllowed": "Der Text enthält einen javascript:-Link. Bitte entfernen Sie ihn – solange er enthalten ist, kann nicht gespeichert werden."
        },
        "404": "Die angeforderte Seite wurde nicht gefunden",
        "title": "Cockpit | Zubehör-Navigator",
        "confirm": "Bestätigen",
        "profile": "Profil",
        "logout": "Abmelden",
        "admin": {
            "contracts": "Verträge",
            "garages": "Autohäuser",
            "products": "Produkte",
            "productCategories": "Kategorien"
        },
        "appName": "ZN Cockpit",
        "fileTooLarge": "Die Datei ist zu groß. Bitte eine Datei mit weniger als 10 MB auswählen.",
        "error": "Es ist ein Fehler aufgetreten",
        "errorMail": {
            "button": "E-Mail senden",
            "subject": "Fehler in ZN App",
            "href": "support@zubehoer-navigator.de"
        },
        "help": {
            "open": "Hilfe öffnen",
            "close": "Hilfe schließen"
        },
        "users": "Nutzerverwaltung",
        "cancel": "Abbrechen",
        "errorNotice": "Bitte versuchen Sie es erneut. Sollte der Fehler weiterhin bestehen, senden Sie uns bitte folgende Informationen an unsere Support-Adresse:",
        "errorSupport": {
            "whatDone": "Was haben Sie zuvor in der Anwendung gemacht?",
            "whichRecord": "Welchen Datensatz hatten Sie gerade auf dem Bildschirm?",
            "whichStep": "Welchen Schritt wollten Sie machen, als der Fehler auftrat?",
            "screenshot": "Schicken Sie uns gerne einen Screenshot oder eine Kopie der folgenden Nachricht."
        },
        "errorDetails": {
            "title": "Fehler-Details",
            "dateTime": "Datum/Uhrzeit",
            "trace": "Trace"
        },
        "copyToClipboard": "In die Zwischenablage kopieren",
        "copied": "In die Zwischenablage kopiert",
        "goBack": "Zurück zur vorherigen Seite",
        "reload": "Seite neu laden",
        "close": "Schließen",
        "confirmDelete": "Soll der Eintrag endgültig gelöscht werden?",
        "confirmLeave": "Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?",
        "leaveStay": "Weiter bearbeiten",
        "leaveConfirm": "Verlassen",
        "dashboard": "Dashboard",
        "garage": "Autohaus",
        "groupGarages": "Autohäuser",
        "productCategories": "Produktkategorien",
        "products": "Produkte",
        "orders": "Bestellungen",
        "helpCenter": "Hilfe-Center",
        "uploadFile": "Wähle Datei",
        "change": "Ändern",
        "edit": "Eintrag Bearbeiten",
        "save": "Änderungen Speichern",
        "selfManage": "Kopieren als eigenes Produkt",
        "delete": "Eintrag Löschen",
        "add": "Eintrag Hinzufügen",
        "details": "Details",
        "userName": "Nutzerkennung",
        "error.required": "Pflicht",
        "coupons": "Rabattcodes",
        "crm": {
            "mailer": "Mailer",
            "customer": "Kundenverwaltung",
            "opportunities": "Verkaufschancen"
        },
        "emailTemplates": "Mail-Design",
        "mailServer": "Mail-Versand",
        "settings": "Einstellungen"
    },
    "crm": {
        "create": "Neuen Kunden anlegen",
        "title": "Kundendetails",
        "prospectInformation": "",
        "salutation": "Anrede",
        "salutationOptions": {
            "MALE": "Herr",
            "FEMALE": "Frau",
            "NONE": "Divers"
        },
        "firstName": "Vorname",
        "lastName": "Nachname",
        "name": "Name",
        "referenceNo": "Kundennummer",
        "email": "E-Mail",
        "phone": "Telefon",
        "vehicleCount": "Fahrzeuge",
        "createdAt": "Erfasst am",
        "consentAccepted": "Einwilligung zur Kontaktaufnahme per E-Mail erteilt",
        "consentSource": "Quelle der Einwilligung",
        "consentSourceOptions": {
            "NOT_SPECIFIED": "Keine Angabe",
            "PURCHASE_AGREEMENT": "Kaufvertrag",
            "REPAIR_ORDER": "Reparaturauftrag"
        },
        "customerInterests": "Kundeninteressen",
        "search": "Kunden suchen",
        "overview": {
            "searchButton": "Suchen",
            "reset": "Zurücksetzen",
            "filter": {
                "onlyMine": "Meine Kunden",
                "unassigned": "Nicht zugeordnet",
                "brand": "Marke",
                "vehicle": "Fahrzeug",
                "deliveryDue": "Auslieferung steht bevor",
                "lastSendingFailed": "Versandfehler",
                "consentMissing": "Einwilligung fehlt",
                "deliveryUnconfirmed": "Lieferdatum nicht bestätigt"
            },
            "filterEmpty": {
                "brand": "Alle Marken",
                "vehicle": "Alle Fahrzeuge"
            },
            "filterAll": "Alle",
            "emptyState": {
                "ONLY_MINE_EMPTY": "Ihnen sind keine Kunden zugeordnet. Mit „Nicht zugeordnet“ sehen Sie Kunden ohne Verkäufer."
            },
            "loadError": "Die Kundenliste konnte nicht geladen werden. Bitte versuchen Sie es erneut oder ändern Sie die Filter.",
            "loadErrorReset": "Die Kundenliste konnte nicht geladen werden. Bitte versuchen Sie es erneut oder setzen Sie die Filter zurück."
        },
        "createSuccess": "Kunde erfolgreich angelegt",
        "saveSuccess": "Kunde erfolgreich gespeichert",
        "salesperson": {
            "label": "Verkäufer",
            "none": "",
            "unknown": "Unbekannt",
            "readOnlyHint": "Der Verkäufer kann hier nicht geändert werden.",
            "droppedHint": "Der gewählte Verkäufer ist nicht mehr verfügbar. Der Kunde wurde ohne Verkäufer gespeichert."
        },
        "createError": "Fehler beim Anlegen des Kunden",
        "saveError": "Fehler beim Speichern des Kunden",
        "saveChanges": "Änderungen speichern",
        "delete": "Kunde löschen",
        "deleteTitle": "Kunde löschen",
        "deleteNotice": "Diesen Kunden wirklich löschen?\n\nDamit werden auch alle Fahrzeugkäufe, Kampagnen und der Mailverlauf gelöscht.",
        "deleteSuccess": "Kunde erfolgreich gelöscht",
        "deleteError": "Fehler beim Löschen des Kunden",
        "status": "Status",
        "statusDeleted": "Gelöscht",
        "deletedOn": "Gelöscht am {{date}}",
        "mailingStatus": "Kampagnen",
        "actionNeed": {
            "column": "Handlungsbedarf",
            "sendingFailed": "Versand fehlgeschlagen",
            "deliveryDue": "Auslieferung steht bevor",
            "consentMissing": "Einwilligung fehlt",
            "dataIncomplete": "Daten unvollständig",
            "attention": "Handlungsbedarf",
            "running": "Kampagne läuft",
            "finished": "Abgeschlossen",
            "noCampaign": "Keine Kampagne",
            "inactive": "Inaktiv"
        },
        "mailingState": {
            "progress": "{{done}} von {{total}} Mails",
            "none": "-"
        },
        "campaignsActiveShort": "aktiv",
        "noOpportunitiesWarning": "Achtung, es sind noch keine Verkaufschancen aktiviert!",
        "campaigns": {
            "title": "Kampagnen",
            "loading": "Kampagnen werden geladen …",
            "empty": "Keine Kampagnen vorhanden.",
            "untyped": "Kampagne",
            "blocked": "Blockiert",
            "noSteps": "Keine Schritte vorhanden.",
            "step": "Schritt",
            "plannedFor": "Geplant für",
            "sentAt": "Versendet am",
            "stepState": "Status",
            "sendFailed": "Fehlgeschlagen",
            "types": {
                "VEHICLE_PURCHASE": "Fahrzeugkauf",
                "BIRTHDATE": "Geburtstag"
            },
            "states": {
                "INITIAL": "Neu",
                "RUNNING": "Aktiv",
                "ON_HOLD": "Pausiert",
                "CANCELED": "Abgebrochen",
                "DEACTIVATED": "Deaktiviert",
                "FINISHED": "Abgeschlossen"
            },
            "stepStates": {
                "DATA_INSUFFICIENT": "Daten fehlen",
                "PLANNED": "Geplant",
                "EXECUTED": "Versendet",
                "SKIPPED": "Übersprungen",
                "CANCELED": "Abgebrochen",
                "DEACTIVATED": "Deaktiviert"
            }
        },
        "mailHistory": {
            "title": "Mailverlauf",
            "subject": "Betreff",
            "sentAt": "Versendet am",
            "state": "Status",
            "loading": "Mailverlauf wird geladen …",
            "empty": "Kein Mailverlauf vorhanden.",
            "scheduleHint": "Automatischer Mailversand: {{schedule}}",
            "states": {
                "PREPARED": "In Vorbereitung",
                "SEND_SUCCESS": "Versendet",
                "SEND_FAILED": "Fehlgeschlagen"
            }
        },
        "consent": "Einwilligung",
        "consentGranted": "Erteilt",
        "consentNotGranted": "Nicht erteilt",
        "addVehiclePurchase": "Fahrzeugkauf hinzufügen",
        "vehiclesAndPurchases": "Fahrzeuge und Käufe",
        "noVehiclesFound": "Es wurden noch keine Fahrzeuge hinzugefügt.",
        "vehiclePurchase": {
            "title": "Fahrzeugkauf",
            "deliveryInformation": "Lieferstatus & Termine",
            "selectVehicle": "Fahrzeug auswählen",
            "editVehicle": "Fahrzeugkauf bearbeiten",
            "contractSignedAt": "Vertrag unterschrieben am",
            "createdAt": "Erstellt am",
            "deliveredAtEstimated": "Voraussichtlicher Liefermonat",
            "deliveredAtEstimatedShort": "Lieferdatum",
            "deliveredAt": "Übergabedatum",
            "deliveryEstimated": "voraussichtlich",
            "deliveryConfirmed": "bestätigt",
            "carline": "Modell",
            "dealership": "Händler",
            "deleteTitle": "Fahrzeugkauf löschen",
            "deleteNotice": "Bitte bestätigen Sie, dass Sie den Fahrzeugkauf wirklich löschen möchten. Diese Aktion kann nicht rückgängig gemacht werden.",
            "deleteSuccess": "Fahrzeugkauf erfolgreich gelöscht",
            "deleteError": "Fehler beim Löschen des Fahrzeugkaufs"
        },
        "opportunities": {
            "title": "Verkaufschancen",
            "listTitle": "Verkaufschancen",
            "listHint": "Wählen Sie eine Verkaufschance aus, um Details zu sehen.",
            "detailsTitle": "Konfiguration",
            "status": {
                "active": "Aktiv",
                "inactive": "Inaktiv"
            },
            "emailsSendingNoBrands": "Es werden keine automatischen E-Mails versendet. Bitte Marktplätze zuordnen.",
            "emailsSendingBrands": "Es werden automatische E-Mails für die folgenden Marken versendet: {{brands}}",
            "templateOnly": "Vorlage",
            "scope": {
                "system": "Systemvorlage",
                "scoped": "Betriebschance"
            },
            "stepsTitle": "E-Mail Phasen",
            "stepType": "Kontaktpunkt",
            "stepDeadline": "Versand",
            "stepDeadlineImmediately": "Sofort",
            "stepDeadlineDays": "{{count}} Tage",
            "stepOrder": "",
            "stepStatus": "Status",
            "stepsCount": "{{count}} E-Mails",
            "noSteps": "Keine Schritte vorhanden.",
            "noOpportunities": "Keine Verkaufschancen vorhanden.",
            "selectPrompt": "Bitte wählen Sie eine Verkaufschance aus, um Details zu sehen.",
            "loadingDetails": "Details werden geladen",
            "sendTrialMail": "Test E-Mail senden",
            "trialMail": {
                "title": "Test E-Mail versenden",
                "description": "Testen Sie den Mailversand direkt an Ihre hinterlegte E-Mail-Adresse. Wenn Sie ein Fahrzeug auswählen, fügen wir automatisch drei passende Produktvorschläge hinzu.",
                "email": "E-Mail senden an",
                "send": "Senden",
                "sendSuccess": "E-Mail erfolgreich versendet",
                "sendError": "die E-Mail konnte nicht versendet werden",
                "validation": {
                    "vehicle": "Bitte wählen Sie ein Fahrzeug aus"
                }
            },
            "types": {
                "VEHICLE_PURCHASE": "Fahrzeugverkauf",
                "WELCOME_MAIL": "Willkommen Mail",
                "ANTICIPATION_MAIL": "Vorfreude Mail",
                "FINAL_MAIL": "Abschluss Mail"
            },
            "description": {
                "VEHICLE_PURCHASE": "3-stufige Email-Kommunikation nach Fahrzeugkauf"
            },
            "vehiclePurchase": {
                "phase": "Phase {{phase}}",
                "welcomeDeadlineImmediately": "Sofort nach Fahrzeugverkauf",
                "welcomeDeadlineDays": "{{count}} Tage nach Fahrzeugverkauf",
                "welcomeContent": "Glückwunsch zum Fahrzeugkauf und 3 Topseller Produktempfehlungen passend zum Fahrzeug",
                "anticipationDeadlineDays": "{{count}} Tage vor Fahrzeugübergabe",
                "anticipationDeadlineWeeks": "{{count}} Wochen vor Fahrzeugübergabe",
                "anticipationContent": "mit Bezug auf die bevorstehende Fahrzeugübergabe, 3 Produktempfehlungen basierend auf den Interessen des Kunden und passend zum Fahrzeug (in späteren Ausbaustufen dann auch ein Coupon)",
                "finalDeadlineDays": "{{count}} Tage nach Fahrzeugübergabe",
                "finalDeadlineWeeks": "{{count}} Wochen nach Fahrzeugübergabe",
                "finalContent": "nach den ersten Wochen, Empfehlung von Produkten welche die tägliche Nutzung des Fahrzeugs erleichtern"
            },
            "loadError": "Verkaufschancen konnten nicht geladen werden",
            "detailsLoadError": "Details konnten nicht geladen werden",
            "activateSuccess": "Verkaufschance aktiviert",
            "activateError": "Verkaufschance konnte nicht aktiviert werden",
            "deactivateSuccess": "Verkaufschance deaktiviert",
            "deactivateError": "Verkaufschance konnte nicht deaktiviert werden"
        },
        "validation": {
            "salutation": {
                "label": "Bitte wählen Sie eine Anrede aus"
            },
            "firstName": "Bitte geben Sie einen Vornamen ein",
            "lastName": "Bitte geben Sie einen Nachnamen ein",
            "referenceNo": "Bitte geben Sie eine Kundennummer ein",
            "emailFormat": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
            "email": "Bitte geben Sie eine E-Mail-Adresse ein",
            "phone": "Bitte geben Sie eine Telefonnummer ein",
            "consentSource": "Bitte geben Sie eine Quelle der Einwilligung ein",
            "formHasErrors": "Bitte beheben Sie die Fehler im Formular, bevor Sie fortfahren."
        }
    },
    "garage": {
        "details": {
            "title": "Autohaus Details"
        },
        "dealerships": {
            "title": "Autohaus Marken"
        },
        "dpa": {
            "title": "Auftragsverarbeitungsvereinbarung",
            "dialogTitle": "Auftragsverarbeitungsvereinbarung (AVV) nach §28 DSGVO",
            "agreementHeader": "Zustimmung AVV",
            "agreementInfo1": "Sie können hier der Vereinbarung zur Auftragsverarbeitung gemäß §28 der Datenschutz-Grundverordnung zustimmen.",
            "agreementInfo2": "Nutzen Sie dazu den Button \"Zustimmung für die AVV digital erteilen\" im Vertrag. Diesen öffnen Sie mit dem Button \"Vertragstext AVV anzeigen\"",
            "agreementButtonReadOnly": "AVV-Vertrag anzeigen",
            "agreementButton": "AVV-Vertrag öffnen und unterschreiben",
            "agreementHeaderWebsite": "Datenschutzerklärung für Ihre Website",
            "agreementInfoWebsite": "Wenn Sie das Homepage-Modul vom Zubehör-Navigator auf Ihrer Website verwenden, dann müssen Sie ihre\n Datenschutzerklärung ergänzen. Bitte kopieren Sie den nachfolgenden Text und fügen Sie ihn in Ihre\n Datenschutzerklärung einfach ein:",
            "agreementInfoWebsiteButton": "Text kopieren",
            "showEnglishTranslation": "Show the english translation",
            "legalNotice": "Bitte beachten Sie: Rechtsverbindlich ist ausschließlich die deutsche Fassung des folgenden Vertrags. Die Übersetzung ist unverbindlich und dient nur zu Ihrer Information.",
            "mandatoryFields": "Pflichtfelder für Autohaus",
            "companyInfo": "Unternehmensinformationen",
            "noRights": "Hinweis: Sie besitzen nicht die notwendigen Berechtigungen um die AVV zu signieren",
            "noRightsGarage": "Hinweis: Sie besitzen nicht die notwendigen Berechtigungen um die Unternehmensinformationen zu bearbeiten",
            "agreement": "Auftragsverarbeitungsvereinbarung",
            "dpaRead": "Ich habe die AVV gelesen",
            "sign": "Zustimmung für die AVV digital erteilen",
            "signing": "Zustimmung wird erteilt...",
            "status": "AVV Status",
            "signed": "Unterschrieben",
            "signedInfo": "Die Zustimmung zur Auftragsverarbeitungsvereinbarung ist erfolgt am <b>{{signatureDate}}</b> von <b>{{signatory}}</b>",
            "dateFormat": "DD.MM.YYYY, HH:mm",
            "notSigned": "Nicht unterschrieben",
            "notSignedInfo": "Die Zustimmung zur AVV ist noch nicht erfolgt. Dies ist notwendig damit Sie den Zubehör-Navigator nutzen können.",
            "signSuccess": "AVV erfolgreich digital zugestimmt",
            "signError": "AVV Zustimmung war nicht erfolgreich",
            "withdraw": "AVV widerrufen",
            "withdrawSuccess": "Widerruf AVV erfolgreich",
            "withdrawError": "Widerruf AVV nicht erfolgreich",
            "confirmWithdraw": "Sind Sie sicher, dass Sie die AVV widerrufen wollen?",
            "loadingTexts": "wird geladen...",
            "validation": {
                "missingValues": "Bitte geben Sie die fehlenden Unternehmensinformationen ein",
                "missingValuesOrDirty": "Der Vertragstext kann nur angezeigt werden, wenn die Unternehmensinformationen vollständig sind und gespeichert wurden."
            },
            "readOnlyInSupportContext": "Im Support-Kontext ist die AVV nur lesbar. Unterschreiben oder widerrufen kann nur das Autohaus selbst."
        }
    },
    "formInformation": {
        "name": "Name",
        "street": "Straße",
        "houseNumber": "Hausnummer",
        "country": "Land",
        "postalCode": "PLZ",
        "city": "Stadt",
        "email": "E-Mail",
        "phoneNumber": "Telefon",
        "fax": "Fax",
        "password": "Passwort",
        "userName": "Nutzername",
        "delete": "Löschen",
        "customerNumber": "Kunden-Nr.",
        "companyName": "Firmenname",
        "managingDirector": "Geschäftsführer"
    },
    "userList": {
        "title": "Nutzerverwaltung",
        "name": "Name",
        "email": "E-Mail",
        "phone": "Telefon",
        "role": "Rolle",
        "userNo": "User-Nr.",
        "buttons": {
            "inviteUser": "Nutzer hinzufügen"
        },
        "status": {
            "title": "Status",
            "ACTIVE": "Aktiv",
            "INACTIVE": "Inaktiv",
            "ACTIVATION_PENDING": "Einladung versendet",
            "ACTIVATION_TIMEOUT": "Einladungsfrist abgelaufen"
        }
    },
    "userDetail": {
        "title": "Nutzerverwaltung",
        "userInformation": "Allgemeine Informationen",
        "name": "Name",
        "email": "E-Mail",
        "emailInvalid": "E-Mail Adresse ist ungültig",
        "phone": "Telefon",
        "role": "Rolle",
        "userNo": "User-Nr.",
        "language": "Sprache",
        "saveSuccess": "Nutzer erfolgreich gespeichert",
        "createSuccess": "Nutzer erfolgreich erstellt",
        "deactivateSuccess": "Nutzer erfolgreich deaktiviert",
        "deleteSuccess": "Nutzer endgültig gelöscht",
        "activateSuccess": "Nutzer erfolgreich aktiviert",
        "isInDebounce": "Nutzer-Aktivierung wurde gerade erst gestartet. \r\n Bitte warten Sie einen Moment, um sie erneut zu starten.",
        "error": {
            "saveFailed": "Nutzer konnte nicht gespeichert werden",
            "createFailed": "Nutzer konnte nicht erstellt werden",
            "createFailedDuplicateMail": "Die Mailadresse ist bereits vergeben",
            "deactivateFailed": "Nutzer konnte nicht deaktiviert werden",
            "deleteFailed": "Nutzer konnte nicht gelöscht werden",
            "activateFailed": "Nutzer konnte nicht aktiviert werden"
        },
        "buttons": {
            "create": "Nutzer erstellen",
            "saveChanges": "Änderungen speichern",
            "removeUser": "Nutzer deaktivieren",
            "deleteUser": "Nutzer endgültig löschen",
            "activateUser": "Nutzer aktivieren",
            "reactivateUser": "Nutzer erneut aktivieren",
            "revokeInvitation": "Einladung widerrufen"
        },
        "removeDialog": {
            "title": "Nutzer deaktivieren",
            "message": "Wollen Sie den Nutzer wirklich deaktivieren? Der Nutzer hat danach keinen Zugriff mehr auf das Cockpit.",
            "confirm": "Nutzer deaktivieren"
        },
        "deleteDialog": {
            "title": "Nutzer endgültig löschen",
            "message": "Wollen Sie {{name}} endgültig löschen? Das Konto und seine Änderungshistorie werden entfernt und lassen sich nicht wiederherstellen.",
            "confirm": "Endgültig löschen"
        },
        "auditTrail": {
            "title": "Änderungshistorie",
            "action": "Änderung",
            "timestamp": "Datum",
            "user": "Benutzer",
            "actions": {
                "CREATE_USER": "Benutzer angelegt",
                "INVITE_USER": "Benutzer per E-Mail eingeladen",
                "RESET_PASSWORD": "Passwort zurückgesetzt",
                "SET_PWD_AND_ACTIVATE": "Passwort gesetzt und Benutzer aktiviert",
                "DEACTIVATE_USER": "Benutzer deaktiviert",
                "ACTIVATE_USER": "Benutzer aktiviert",
                "PERMISSION_ASSIGNED": "Berechtigung zugewiesen",
                "PERMISSION_REVOKED": "Berechtigung entzogen",
                "ROLE_ASSIGNED": "Rolle zugewiesen",
                "MODIFY_SALUTATION": "Anrede geändert",
                "MODIFY_NAME": "Name geändert",
                "MODIFY_EMAIL": "E-Mail Adresse geändert",
                "MODIFY_LANGUAGE": "Benutzersprache geändert",
                "MODIFY_PHONE": "Telefonnummer geändert",
                "GROUP_SCOPE_ASSIGNED": "Benutzer einer Autohausgruppe zugeordnet",
                "GARAGE_SCOPE_ASSIGNED": "Benutzer einem Autohaus zugeordnet",
                "DISTRIBUTOR_SCOPE_ASSIGNED": "Benutzer einem Hersteller zugeordnet"
            }
        }
    },
    "myGarage": {
        "garageDetails": {
            "title": "Autohaus-Daten",
            "garage": "Autohaus / Betrieb",
            "registry": "Registergericht",
            "addressAndContact": "Adresse & Kontakt",
            "configuration": "Mailserver-Konfiguration",
            "senderName": "Absender-Name",
            "senderEmail": "Absender-E-Mail-Adresse",
            "host": "Host",
            "port": "Port",
            "ssl": "SSL/TLS",
            "smtpInformation": "Anmeldeinformationen SMTP",
            "serverInformation": "Serverinformationen",
            "userInformation": "Benutzerinformationen",
            "standardPort": "Standard Port",
            "saveSuccess": "Daten erfolgreich gespeichert",
            "saveError": "Fehler beim Speichern der Daten",
            "euShop": "Verkauf von Waren muss nach EU-Recht erfolgen",
            "euShopYes": "Ja",
            "euShopNo": "Nein",
            "euShopTooltip": "Wenn Sie an Kunden aus einem EU-Land verkaufen, muss der Verkauf nach geltendem EU-Recht erfolgen. Im Shop werden dann u. a. die EU-Garantie-Labels angezeigt."
        },
        "account": {
            "group": "Gruppe",
            "noGroup": "keine Gruppe",
            "openGroup": "Gruppe öffnen"
        },
        "location": {
            "title": "Vertrieb",
            "dataLocation": "Geo-Daten Standort",
            "latitude": "Breitengrad",
            "longitude": "Längengrad",
            "countries": "Verkaufsländer",
            "viewDealershipLocation": "Ansicht Autohaus für Standortsuche",
            "picFormat": "Bitte wählen Sie hier nur Bilddateien im Format .jpg aus. Die Datei sollte eine Größe von höchstens 1 MB (ca. 800 × 500 Pixel) nicht überschreiten.",
            "chooseFile": "Datei wählen"
        },
        "contract": {
            "status": "Status Auftragsverarbeitung",
            "agreement": "AVV zugestimmt",
            "date": "Datum",
            "signed": "Unterzeichnet"
        },
        "dealership": {
            "title": "Autohaus Marken",
            "editDetails": "Details bearbeiten",
            "dealerNumber": "Händler-Nr.",
            "dealerData": "Händlerdaten",
            "hourlyRateTitle": "Stunden-Verrechnungssatz",
            "hourlyRateNotice": "Stunden-Verrechnungssatz (inkl. MwSt.)\n1 Stunde = 10 AW",
            "configNonExistent": "Die Daten der Shop Konfiguration sind nicht verfügbar.",
            "dealerAliasNo": "Alternative Händler-Nr.",
            "inVacation": "Diesen Händler von allen Suchergebnissen ausschließen",
            "imprintLink": "Link zu den rechtlichen Hinweisen / Impressum",
            "dataPrivacyLink": "Link zur Datenschutzerklärung",
            "modify": {
                "success": "Marke erfolgreich gespeichert",
                "error": "Speichern der Marke fehlgeschlagen"
            },
            "noDealerships": "Für dieses Autohaus wurden noch keine Händler angelegt",
            "notFound": "Marke konnte nicht geladen werden",
            "legalTexts": {
                "title": "Rechtstexte",
                "agbTitle": "Allgemeine Geschäftsbedingungen (AGB)",
                "widerrufTitle": "Widerrufsbelehrung",
                "widerrufLinkLabel": "Link zur Widerrufsbelehrung",
                "widerrufLinkNotice": "Ist ein Link hinterlegt, wird im Shop nur der Link angezeigt – der gepflegte Widerrufstext bleibt gespeichert, wird aber nicht verwendet.",
                "widerrufTextNotice": "Ohne Link wird der hier gepflegte Widerrufstext im Shop angezeigt.",
                "saveError": "Fehler beim Speichern der Rechtstexte",
                "modeText": "Text pflegen",
                "modeLink": "Link verwenden",
                "imprintTitle": "Impressum",
                "privacyTitle": "Datenschutzerklärung",
                "imprintLinkNotice": "Ist ein Link hinterlegt, zeigt der Shop nur den Link; der gepflegte Text bleibt gespeichert.",
                "imprintTextNotice": "Ohne Link zeigt der Shop diesen Text, ergänzt um das Impressum von IT-Tecture als Betreiber.",
                "privacyLinkNotice": "Ist ein Link hinterlegt, zeigt der Shop nur den Link, auch in den Anfrage- und Teilen-Formularen; der gepflegte Text bleibt gespeichert.",
                "privacyTextNotice": "Ohne Link zeigt der Shop diesen Text. Ist er leer, erscheint die Standard-Datenschutzerklärung des Zubehör-Navigators."
            }
        }
    },
    "garages": {
        "pagination": {
            "total": "Händler gesamt",
            "pages": "Anzeige Seiten",
            "showNumberOfDealer": "Anzeige Anz. Händler"
        },
        "company": "Firma/Betrieb",
        "dealer": "Vertragshändler"
    },
    "productCategory": {
        "section": "Kategorie Details",
        "name": "Name",
        "subTitle": "Untertitel",
        "language": "Sprache",
        "position": "Position",
        "actions": "Aktionen",
        "image": "Bild",
        "imageChange": "Bild ändern"
    },
    "productCategories": {
        "buttons": {
            "addCategory": "Kategorie hinzufügen",
            "editCategory": "Kategorie bearbeiten",
            "deleteCategory": "Kategorie löschen",
            "changeSortOrder": "Reihenfolge speichern"
        },
        "help": {
            "title": "Hilfe zur Produktkategorienverwaltung",
            "sectionTitle": "Produktkategorien",
            "sectionDescription": "Hier können Sie Ihre eigenen Produktkategorien anlegen und verwalten. Diese Kategorien können Sie später für Ihre Produkte unabhängig von den Katalogen verwenden. Diese werden im Homepage-Modul entweder vor oder nach den Katalog-Kategorien angezeigt."
        },
        "createCategory": "eigene Kategorie anlegen",
        "image": "Bild",
        "name": "Name",
        "subTitle": "Untertitel",
        "language": "Sprache",
        "position": "Position",
        "actions": "Aktionen",
        "noCategoriesYetMsg": "Es wurden noch keine Produktkategorien angelegt",
        "catalogCategoriesDivider": "Katalog Kategorien werden hier angezeigt",
        "validation": {
            "name": "Bitte einen Namen eingeben",
            "language": "Bitte eine Sprache auswählen"
        },
        "sortOrderSaved": "Reihenfolge erfolgreich gespeichert",
        "sortOrderSaveError": "Fehler beim Speichern der Reihenfolge",
        "saveSuccess": "Kategorie erfolgreich gespeichert",
        "saveError": "Fehler beim Speichern der Kategorie",
        "deleteSuccess": "Kategorie erfolgreich gelöscht",
        "deleteError": "Fehler beim Löschen der Kategorie"
    },
    "product": {
        "priceHistory": {
            "chart": {
                "price": "Preis",
                "rrp": "UVP"
            },
            "title": "Preishistorie",
            "date": "Datum",
            "loading": "Preishistorie wird geladen...",
            "price": "Preis",
            "status": "Status",
            "valid": "Gültig",
            "invalid": "Ungültig",
            "actions": "Aktionen",
            "noValidEntries": "Keine Preisänderungen gefunden",
            "noProductNo": "Keine Produktnummer angegeben",
            "markInvalid": {
                "title": "Änderungsgrund eintragen",
                "description": "Sie wollen Änderungen an der Preisgültigkeit vornehmen. Bitte geben Sie den Grund an.",
                "warningTitle": "EU-OMNIBUS-RICHTLINIE beachten",
                "warningText": "Änderungen an der Preisgültigkeit sollten nur vorgenommen werden, wenn Sie einen berechtigten Grund haben. Ungerechtfertigte Änderungen können rechtliche Konsequenzen haben.",
                "reason": "Grund für Ungültigkeit",
                "reasonPlaceholder": "z.B. Fehlerhafte Eingabe",
                "confirm": "Als ungültig markieren",
                "cancel": "Abbrechen"
            }
        },
        "productDetails": {
            "createProduct": "Eigenes Produkt anlegen",
            "title": "Produktdetails",
            "success": "Produkt erfolgreich gespeichert",
            "error": "Fehler beim Speichern des Produkts",
            "delete": "Produkt löschen",
            "confirmDelete": "Soll das Produkt endgültig gelöscht werden?",
            "deleteSuccess": "Produkt erfolgreich gelöscht",
            "deleteError": "Fehler beim Löschen des Produktes",
            "media": {
                "title": "Bilder",
                "dropzoneHint": "Ziehen Sie Ihre Dateien hierher oder klicken Sie, um sie hochzuladen.<br/><br/>Bildauflösung: max 3.000 x 2.000 Pixel<br/>Dateigröße: max. 10MB<br/>Unterstützte Formate: jpg, png, webp",
                "dropHere": "Hier ablegen",
                "images": {
                    "title": "Produktbilder",
                    "currentFavorite": "aktuelles Galeriebild",
                    "add": {
                        "title": "Produktbild hinzufügen"
                    },
                    "actions": {
                        "favorite": "als Galeriebild verwenden",
                        "unfavorite": "als Galeriebild entfernen"
                    }
                },
                "videos": {
                    "url": "Url",
                    "preview": "Vorschaubild",
                    "title": "Videos",
                    "titleNew": "Video hinzufügen"
                },
                "validation": {
                    "media": "Bitte ein Produktbild auswählen"
                }
            },
            "general": {
                "title": "Allgemeine Informationen",
                "name": "Name",
                "partNos": "Teilenummern",
                "category": "Kategorien",
                "referenceNumber": "Referenznummer",
                "validationErrors": {
                    "REFERENCE_NO_MISSING": "Referenznummer fehlt",
                    "PRODUCT_PRICE_MISSING": "Preis fehlt",
                    "PRODUCT_TITLE_MISSING": "Name fehlt",
                    "PRODUCT_DESCRIPTION_MISSING": "Beschreibung fehlt",
                    "PRODUCT_NATURE_MISSING": "Produktart fehlt",
                    "PRODUCT_IMAGE_MISSING": "Produktbild fehlt",
                    "PRODUCT_CATEGORY_MISSING": "Kategorie fehlt",
                    "PRODUCT_CATEGORY_INVALID": "Kategorie ungültig",
                    "PRODUCT_PARTS_MISSING": "Teilenummer fehlt",
                    "PRODUCT_PLATFORM_DEPENDENCY_INVALID": "Abhängigkeit Marktplatz ungültig",
                    "PRODUCT_CARLINE_INVALID": "Fahrzeugzuordnung ungültig",
                    "PRODUCT_PUBLISHING_REJECTED": "Produkt wurde abgelehnt"
                },
                "fieldErrors": {
                    "DUPLICATE_REF_NO": "Referenznummer muss innerhalb eines Katalogs eindeutig sein"
                },
                "nature": {
                    "label": "Produktart",
                    "ACCESSORY": "Zubehör",
                    "LIFESTYLE": "Lifestyle",
                    "WHEEL": "Räder & Reifen",
                    "SOFTWARE": "Software"
                },
                "condition": {
                    "label": "Artikelzustand",
                    "NEW": "Neu",
                    "REFURBISHED": "Aufgearbeitet",
                    "USED": "Gebraucht"
                },
                "language": {
                    "label": "Sprache",
                    "de": "Deutsch",
                    "en": "Englisch",
                    "fr": "Französisch",
                    "sv": "Schwedisch"
                },
                "validation": {
                    "longDescription": "Bitte eine Beschreibung eingeben"
                }
            },
            "contentSize": {
                "title": "Mengenangaben für Berechnung des Grundpreises",
                "required": "Angabe Grundpreis ist erforderlich",
                "unit": "Einheit",
                "value": "Menge",
                "unitTypes": {
                    "METRE": "m",
                    "MILLI_METRE": "mm",
                    "LITRE": "l",
                    "MILLI_LITRE": "ml",
                    "KILO_GRAM": "kg",
                    "GRAM": "g",
                    "SQUARE_METRE": "m²",
                    "SQUARE_MILLI_METRE": "mm²",
                    "CUBIC_METRE": "m³",
                    "CUBIC_MILLI_METRE": "mm³"
                }
            },
            "selectRelevantDistributors": "Bitte wählen Sie eine oder mehrere relevante Marken aus",
            "errorSelectAtLeastOneDistributor": "Es muss mindestens eine Marke ausgewählt werden",
            "ownCatalogLabel": "Eigene Produktkategorie",
            "selectCatalogSource": "Bitte wählen Sie eine Quelle aus",
            "selectCategoryFromSource": "Bitte wählen Sie eine Kategorie aus",
            "errorSelectCategory": "Es muss eine Kategorie ausgewählt werden",
            "noCategoriesInSelectedSource": "Keine Kategorien in der gewählten Quelle verfügbar",
            "noCarlinesAvailable": "Keine Fahrzeuge verfügbar",
            "errorSelectedCategoryDeprecated": "Die ausgewählte Kategorie ist nicht mehr verfügbar. Bitte wählen Sie eine andere Kategorie aus",
            "errorSelectedCarlinesDeprecated": "Einige zugeordnete Fahrzeuge sind nicht mehr verfügbar. Bitte entfernen Sie diese aus der Auswahl",
            "removeDeprecatedCarlines": "Nicht mehr verfügbare entfernen",
            "deprecatedBadge": "nicht mehr verfügbar",
            "deprecatedTooltip": "Dieser Eintrag ist nicht mehr verfügbar und kann nicht neu zugeordnet werden. Bitte entfernen Sie die Zuordnung.",
            "errorSelectSource": "Es muss eine Quelle ausgewählt werden",
            "carlineSystem": "Fitment",
            "dealerSection": "Zum Katalog zuordnen",
            "fitments": "Fahrzeugzuordnungen",
            "description": "Beschreibung",
            "priceHistory": {
                "title": "Preishistorie (EU-Omnibus-Richtlinie)",
                "description": "Übersicht der Preisänderungen der letzten 30 Tage gemäß EU-Omnibus-Richtlinie",
                "loading": "Preishistorie wird geladen...",
                "noEntries": "Keine Preisänderungen in den letzten 30 Tagen gefunden",
                "date": "Datum",
                "previousPrice": "Vorheriger Preis",
                "newPrice": "Neuer Preis",
                "status": "Status",
                "actions": "Aktionen",
                "valid": "Gültig",
                "invalid": "Ungültig",
                "markInvalid": {
                    "title": "Eintrag als ungültig markieren",
                    "description": "Geben Sie einen Grund an, warum dieser Preiseintrag als ungültig markiert werden soll:",
                    "reason": "Grund für Ungültigkeit",
                    "confirm": "Als ungültig markieren"
                }
            },
            "gpsr": {
                "title": "Allgemeine Produktsicherheitsverordnung (GPSR)",
                "general": {
                    "title": "Allgemeine Informationen",
                    "make": "Marke"
                },
                "common": {
                    "recipient": "Empfänger",
                    "recipientLine2": "Empfänger (Zusatz)",
                    "street": "Straße",
                    "streetLine2": "Straße (Zusatz)",
                    "postCode": "PLZ",
                    "city": "Stadt",
                    "state": "Bundesland",
                    "country": "Land",
                    "email": "E-Mail",
                    "website": "Webseite",
                    "phone": "Telefon"
                },
                "producer": {
                    "title": "Hersteller"
                },
                "representative": {
                    "title": "Repräsentant"
                },
                "errorProducer": "Die Angaben zum Hersteller sind unvollständig (mindestens Empfänger, Straße, PLZ, Stadt)",
                "errorRepresentative": "Die Angaben zum Repräsentant sind unvollständig (mindestens Empfänger, Straße, PLZ, Stadt)"
            },
            "manufacturerWarranty": {
                "title": "Herstellergarantie",
                "sectionTitle": "Angaben zur Garantie",
                "modelIdentifier": "Modellbezeichnung",
                "durationYears": "Garantiedauer (Jahre)",
                "error": "Bitte Modellbezeichnung und Garantiedauer gemeinsam angeben oder beide Felder leer lassen"
            },
            "price": {
                "retailPrice": "Unverbindliche Preisempfehlung (UVP)",
                "vatRate": "MwSt",
                "title": "Preisinformationen",
                "rrp": "UVP",
                "fixedPrice": "Eigener Preis",
                "percentageFromRrp": "Preis anpassen um",
                "lowestPrice30Days": "30-Tage-Tiefpreis",
                "specialOffer": "Wird als Sonderangebot angezeigt",
                "noSpecialOffer": "Kein Sonderangebot",
                "copyRrpNoOfferHint": "Mit der Preisregel \"UVP\" ist kein Sonderangebot möglich",
                "validation": {
                    "retailPriceValue": "Bitte eine Unverbindliche Preisempfehlung (UVP) eingeben",
                    "vatRate": "Bitte eine Umsatzsteuer angeben"
                }
            },
            "options": {
                "title": "Einstellungen Produkt"
            },
            "shipping": {
                "title": "Verkaufsoptionen",
                "shipping": "Versand",
                "shippingCosts": "Versandkosten",
                "shippingCostsZero": "Versandkostenfrei",
                "pickup": "Abholung",
                "mounting": "Montage",
                "mountingLabourValue": "Arbeitswert",
                "workUnit": "AW",
                "noCatalogueValue": "Kein Arbeitswert im Katalog",
                "isCatalogueValue": "Der Arbeitswert wurde bereits auf den Katalogwert gesetzt",
                "resetToCatalogue": "Auf Katalogwert zurücksetzen",
                "catalogueMountingLabourValue": "Arbeitswert Katalog",
                "catalogueMountingCost": "Montagekosten Katalog",
                "pricingOverview": {
                    "title": "Preisübersicht:",
                    "productPrice": "Produktpreis:",
                    "mountingCosts": "Montagekosten:",
                    "priceInclMounting": "Preis inkl. Montage:",
                    "shippingCosts": "Versandkosten:",
                    "priceInclShipping": "Preis inkl. Versand:"
                },
                "validation": {
                    "options": "Bitte mindestens eine Option auswählen"
                }
            },
            "receivability": {
                "title": "Verfügbarkeit",
                "IMMEDIATELY": "Sofort (binnen 24h)",
                "STANDARD": "Standard (1-2 Werktage)",
                "SHORT_TERM": "Kurzfristig (3-5 Werktage)",
                "MID_TERM": "Mittelfristig (5-8 Werktage)",
                "LONG_TERM": "Langfristig (mehr als 10 Werktage)"
            },
            "singleItem": {
                "label": "Einzelartikel – nur 1× verfügbar",
                "explanation": "Aktivieren Sie diese Option, wenn Sie von diesem Artikel nur ein einziges Exemplar besitzen.",
                "warning": "Achtung: Sobald dieser Artikel einmal verkauft wurde, ist er nicht mehr verkäuflich und wird von allen Marktplätzen entfernt. Sie können den Artikel später erneut auf dieser Seite aktivieren."
            },
            "deactivatedHint": "Dieses Produkt wird derzeit nicht veröffentlicht, es ist kein Marktplatz ausgewählt. Wenn Sie das Produkt wieder anbieten wollen, aktivieren Sie einen Marktplatz unten auf der Seite.",
            "platforms": {
                "title": "Marktplätze",
                "HPM": "Zubehör-Navigator",
                "GOOGLE_SHOPPING": "Google Shopping",
                "AMAZON": "Amazon",
                "EBAY": "eBay",
                "UNKNOWN": "unbekannt",
                "googleShoppingDisclaimer": "Bitte beachten: Google Shopping kann nur aktiviert werden, wenn das Produkt versendet werden kann und bereits im Zubehör-Navigator aktiviert wurde.",
                "locked": {
                    "notConfigured": "Für diesen Händler nicht eingerichtet.",
                    "requiresShippingAndHpm": "Nur mit Versand und aktiviertem Zubehör-Navigator möglich."
                },
                "validation": {
                    "platforms": "Bitte mindestens einen Marktplatz auswählen"
                }
            },
            "interests": {
                "title": "Kundeninteressen",
                "explanation": "Kunden, welche sich für dieses Produkt interessieren, könnten die folgenden Interessen haben:",
                "notice": "Die Interessen wurden von der Zubehör Navigator KI ermittelt und sind möglicherweise derzeit nicht ganz zutreffend.",
                "noneAvailable": "Es sind noch keine Kundeninteressen angegeben. Sie werden automatisch aus den bereitgestellten Texten generiert. Dies kann einige Zeit dauern und möglicherweise keine Ergebnisse liefern.",
                "BICYCLE": "Fahrradfahrer",
                "CHILDREN": "Kinder",
                "COMMUTER": "Pendler",
                "DOG_OWNER": "Hundebesitzer",
                "DONKEY": "Auto als Arbeitstier",
                "ELECTRIC_VEHICLE": "E-Auto Zubehör",
                "OUTDOOR": "Outdoor und Aktiv-Urlaub",
                "WINTER": "Winter-Zubehör",
                "SUMMER": "Sommer-Zubehör",
                "WINTERSPORT": "Wintersport"
            },
            "selfManage": {
                "success": "Produkt wurde erfolgreich als eigenes Produkt überführt.",
                "error": "Fehler beim Erstellen eines eigenen Produktes.",
                "dialogTitle": "In Eigene Produkte kopieren?",
                "dialogDescription": "Hiermit kopieren Sie das Produkt, und erstellen daraus ein eigenes Produkt.\nAlle Daten werden übernommen, und das Eigene Produkt wird auf den Marktplätzen aktiviert.\nNach dem Kopieren werden die Marktplätze auf dem ursprünglichen Produkt deaktiviert.\nIm Anschluss werden Sie auf die Übersicht der Eigenen Produkte weitergeleitet.",
                "confirm": "In Eigene Produkte kopieren"
            }
        },
        "errorNoCatalogs": "Keine Kataloge veröffentlicht oder Haupthändler noch nicht hinzugefügt."
    },
    "productOverview": {
        "garageSelector": "Autohaus-Auswahl",
        "catalogSelector": "Katalogauswahl",
        "catalogSelectorPlaceholder": "Katalogauswahl",
        "customCatalog": "Eigene Produkte",
        "filterApply": "Filter anwenden",
        "buttons": {
            "manageCategories": "Kategorien verwalten",
            "addProduct": "Produkt hinzufügen",
            "massUpdate": "Produkte bearbeiten",
            "republish": "Erneut veröffentlichen"
        },
        "pagination": {
            "total": "Produkte gesamt",
            "pages": "Anzeige Seiten",
            "showNumberOfProducts": "Anzeige Anz. Produkte"
        },
        "product": "Produkt",
        "image": "Bild",
        "manufacturer": "Hersteller",
        "partNos": "Teilenummern",
        "label": "Bezeichnung",
        "categories": "Kategorien",
        "fitment": "Fahrzeuge",
        "retailPrice": "UVP",
        "purchasePrice": "Materialpreis",
        "labour": "Arbeitswert",
        "shipping": "Versand",
        "pickup": "Abholung",
        "mounting": "Montage",
        "platforms": "Marktplätze",
        "noGarage": "Kein Autohaus oder Autohausgruppe ausgewählt. Bitte wählen Sie ein Autohaus um Produkte anzuzeigen",
        "republishDialog": {
            "title": "Produkte erneut veröffentlichen",
            "message_one": "Das Produkt des aktuellen Filters wird erneut an seine Marktplätze übertragen. Das kann einige Minuten dauern.",
            "message_other": "Alle {{count}} Produkte des aktuellen Filters werden erneut an ihre Marktplätze übertragen. Das kann einige Minuten dauern.",
            "confirm": "Erneut veröffentlichen"
        },
        "republishStarted": "Die Produkte werden erneut veröffentlicht",
        "republishFailed": "Die Produkte konnten nicht erneut veröffentlicht werden"
    },
    "productMassUpdate": {
        "title": "Bearbeiten von ausgewählten Produkten",
        "sectionTitle": "Änderungen",
        "filter": {
            "title": "Filterkriterien",
            "catalogLabel": "Katalog",
            "productCountWarning": "Die Änderungen werden auf {{productCount}} Produkte angewendet!"
        },
        "prices": {
            "title": "Verkaufspreise",
            "label": "",
            "percentFromRRP": "bezogen auf den UVP",
            "options": {
                "NO_CHANGES": "keine Änderung",
                "USE_RRP": "auf UPE setzen",
                "PRICE_CHANGE_PERCENTAGE": "Prozentuale Anpassung"
            }
        },
        "sellingOptions": {
            "title": "Verkaufsoptionen",
            "pickup": {
                "title": "Abholung",
                "options": {
                    "NO_CHANGES": "keine Änderung",
                    "AVAILABLE": "verfügbar",
                    "UNAVAILABLE": "nicht verfügbar"
                }
            },
            "shipping": {
                "title": "Versand",
                "changeCosts": "Porto & Versand ändern",
                "shippingCostsZero": "Versandkostenfrei",
                "options": {
                    "NO_CHANGES": "keine Änderung",
                    "AVAILABLE": "verfügbar",
                    "UNAVAILABLE": "nicht verfügbar"
                }
            },
            "mounting": {
                "title": "Montage",
                "mountingLabourValurPrefix": "AW",
                "options": {
                    "NO_CHANGES": "keine Änderung",
                    "AVAILABLE": "verfügbar",
                    "UNAVAILABLE": "nicht verfügbar"
                },
                "labourValue": {
                    "label": "Eigener Arbeitswert",
                    "options": {
                        "NO_CHANGES": "keine Änderung",
                        "SET": "setzen",
                        "REMOVE": "entfernen"
                    }
                }
            }
        },
        "availability": {
            "title": "Verfügbarkeit",
            "options": {
                "IMMEDIATELY": "Sofort (binnen 24h)",
                "STANDARD": "Standard (1-2 Werktage)",
                "SHORT_TERM": "Kurzfristig (3-5 Werktage)",
                "MID_TERM": "Mittelfristig (5-8 Werktage)",
                "LONG_TERM": "Langfristig (mehr als 10 Werktage)",
                "NO_CHANGES": "keine Änderung"
            }
        },
        "platforms": {
            "title": "Für Märkte Ein-/Abschalten",
            "options": {
                "NO_CHANGES": "keine Änderung",
                "DEACTIVATE": "ausschalten",
                "ACTIVATE": "einschalten"
            }
        },
        "buttons": {
            "save": "Änderungen anwenden"
        },
        "saveSuccess": "Änderungen wurden erfolgreich angewendet",
        "saveFailure": "Die Anwendung der Änderungen war nicht erfplgreich"
    },
    "login": {
        "registerButton": "Weiter zur Anmeldung",
        "appName": "ZN-Cockpit",
        "subTitle": "Verwaltungsarbeitsplatz für Zubehör im AfterSales Geschäft",
        "news": {
            "items": [
                {
                    "title": "Willkommen in unserer neuen Verwaltungsoberfläche",
                    "description": "Dürfen wir vorstellen: Unser neues \"Cockpit\".\nUnser gesamtes Team hat sich viel Mühe gegeben, um Ihnen das Arbeiten mit dem Zubehör-Navigator noch leichter machen. Ihre Anmeldedaten bleiben natürlich bestehen. Loggen Sie sich ein und testen Sie Ihr neues Cockpit. Wir freuen uns über Feedback zum neuen Cockpit telefonisch oder per E-Mail unter: <a href=\"tel:+49381666989100\">+49 381 666 989 100</a> oder <a href=\"mailto:support@zubehoer-navigator.de\">support@zubehoer-navigator.de</a>"
                },
                {
                    "title": "80% des Zubehör-Umsatzes werden im Zusammenhang mit Fahrzeugverkäufen erzielt.",
                    "description": "… leider wird dieses Potenzial in den Autohäusern noch viel zu wenig genutzt. Das wollen wir ändern!\nMit dem Zubehör-Kommunikator für Neu- und Gebrauchtwagen steht Ihnen ab sofort eine neue Funktion zur Verfügung, mit der Sie Ihre Fahrzeugkunden gezielt zum Thema Zubehör ansprechen können. So erreichen Sie Ihre Kunden zum Zeitpunkt des höchsten Interesses."
                },
                {
                    "title": "Nutzen Sie die Fahrzeugübergabe für den Verkauf von Zubehör",
                    "description": "Steigern sie ihren Zubehörverkauf mit maßgeschneiderten Coupons, passend zu ihrer Marke. Wir übernehmen den Druck und Versand. Sie profitieren von mehr Umsatz und einer stärkeren Kundenbindung."
                }
            ],
            "footerText": "Sie sind noch kein Kunde beim Zubehör-Navigator? Alle Informationen finden Sie auf ",
            "footerLinkText": "unserer Website"
        },
        "copyright": "IT-Tecture. Alle Rechte vorbehalten."
    },
    "contracts": {
        "contracts": "Verträge",
        "createContract": "Angebot wurde erstellt!",
        "close": "Schließen",
        "openContract": "Vertrag link kopieren",
        "customerDetail": {
            "title": "Kundendaten",
            "submit": "Abschicken",
            "opportunity": "Opportunity",
            "opportunityId": "Opportunity ID",
            "contact": {
                "contactData": "Kontaktdaten",
                "accountName": "Autohaus-Name",
                "email": "Email",
                "telephone": "Telefon",
                "mobile": "Mobil",
                "name": "Name",
                "city": "Stadt",
                "postalCode": "PLZ",
                "street": "Straße",
                "country": "Land",
                "address": "Adresse"
            }
        },
        "tariffCalculation": {
            "totalPrice": "Gesamtpreis",
            "calculateButton": "Berechnen",
            "createOffer": "Angebot Erstellen",
            "title": "Tarifberechnung",
            "tariffBoxTitle": "Tarif & Laufzeit",
            "product": "Tarif",
            "project": "Preisliste",
            "projectError": "Tarif wählen!",
            "productError": "Preisliste wählen!",
            "brandError": "Anzahl fehlt!",
            "locationError": "Anzahl fehlt!",
            "opportunityError": "Opportunity unvollständig oder nicht vorhanden!",
            "number": "Anzahl",
            "location": "Standort",
            "perLocations": "je Standort",
            "selectPlaceholder": "Marken Auswählen",
            "duration": "Laufzeit",
            "selectError": "Bitte wählen Sie eine Marke aus",
            "durationError": "Bitte wählen Sie eine Laufzeit aus",
            "expiryDateError": "Bitte wählen Sie ein Ablaufdatum aus",
            "monthlyCostSection": {
                "title": "Monatliche Kosten",
                "brands": "Anzahl Marken",
                "groupModule": "Gruppen-Modul",
                "uclLicense": "Fahrzeug-Börse",
                "baseCost": "Grundgebühr (inkl. eine Marke)",
                "location": "Anzahl Standorte",
                "uclLicensePerLocation": "Modul für die Fahrzeugbörse",
                "groupModulePerLocation": "Gruppenmodul",
                "brandSurchargePerLocation": "Markenaufschlag (pro zusätzliche Marke)"
            },
            "setUpCostSection": {
                "title": "Einrichtungskosten"
            },
            "types": {
                "tablet": "Anzahl Tablets",
                "tabletTerminal": "Anzahl Halter für Tablets",
                "qrCodeSets": "QR Magnetfolien (Sets)",
                "qrCodeHanger": "QR Spiegelanhänger",
                "qrStickerRoll": "QR Sticker Rolle",
                "expiryDate": "Ablaufdatum",
                "monthlyDiscount": "Monatlicher Rabatt",
                "discount": "Einmaliger Rabatt"
            },
            "additionalConditions": "Besondere Vertragsbedingungen"
        },
        "contractList": {
            "accountName": "Konto-Name",
            "offerNumber": "Angebot-Nr.",
            "status": "Status",
            "contractManager": "Erstellt durch",
            "date": "Datum",
            "offerLink": "URL für Kunden",
            "addContract": "Vertrag Hinzufügen",
            "created": "Neu",
            "draft": "Entwurf",
            "signed": "Unterzeichnet",
            "deleted": "Gelöscht",
            "expired": "Abgelaufen",
            "submitted": "Publiziert",
            "canceled": "Storniert",
            "gone": "Geschlossen",
            "copyLink": "Link Kopieren",
            "tooltipCopyLink": "Link kopiert",
            "cancelSuccess": "Vertrag wurde storniert"
        }
    },
    "garageList": {
        "details": {
            "toggle": "Details ein-/ausblenden",
            "customerNumber": "Kunden-Nr.",
            "accountsReceivableNo": "Debitoren-Nr.",
            "address": "Adresse",
            "group": "Gruppe",
            "email": "E-Mail",
            "phone": "Telefon"
        },
        "title": "Autohäuser der Gruppe",
        "customerNumber": "Kunden-Nr.",
        "garageName": "Firma/Betrieb",
        "postalCode": "PLZ",
        "city": "Stadt",
        "country": "Land",
        "nsc": "Vertragshändler",
        "customerActive": "Kunde aktiv",
        "noActivity": "keine Aktivität seit 30 Tagen",
        "noAgreement": "Keine AVV",
        "addGarage": "Autohaus hinzufügen",
        "removeGarage": "Autohaus löschen",
        "garageListFilter": {
            "title": "Filter",
            "placeholder": "Autohäuser nach Name, Kunden-Nr, Adresse finden",
            "country": "Länder",
            "brand": "Marken",
            "nsc": "NSC",
            "searchButton": "Suchen",
            "resetButton": "Alle Filter löschen"
        },
        "buttons": {
            "dpaMassUpdate": "AVV unterzeichnen"
        },
        "dpa": {
            "title": "AVV für alle Autohäuser unterschreiben",
            "agreeFirstInfo": "Bevor Sie weiterarbeiten können, bitte \"AVV unterzeichnen\" klicken und den AVVs zustimmen.",
            "signGarages": "Für folgende Standorte wird die AVV erteilt:",
            "garagesMissingData": "Bei folgenden Standorten kann die AVV nicht erteilt werden, da die Unternehmensdaten nicht vollständig sind:",
            "signSuccess": "Zustimmung zu AVVs erfolgreich erteilt",
            "signError": "Zustimmung zu AVVs war nicht erfolgreich",
            "buttons": {
                "agreeAll": "Restliche AVV unterzeichnen",
                "agreeValid": "Gültige AVV unterzeichnen"
            }
        }
    },
    "user": {
        "title": "Kontensteuerung",
        "account": {
            "title": "Mein Nutzerkonto",
            "personalData": "Persönliche Daten",
            "salutation": {
                "label": "Anrede:",
                "MALE": "Herr",
                "FEMALE": "Frau",
                "NONE": "Divers"
            },
            "email": "E-Mail",
            "name": "Name",
            "phone": "Telefon",
            "language": "Sprache",
            "success": "Änderungen erfolgreich gespeichert",
            "error": "Fehler beim Speichern",
            "appearance": {
                "title": "Darstellung",
                "description": "Wähle das Farbschema für die Oberfläche.",
                "system": "Systemvorgabe",
                "light": "Hell",
                "dark": "Dunkel"
            }
        },
        "password": {
            "title": "Passwort",
            "change": "Passwort ändern",
            "oldPassword": "Bestehendes Passwort",
            "newPassword": "Neues Passwort",
            "newPasswordConfirm": "Passwort bestätigen",
            "success": "Passwort erfolgreich geändert",
            "error": "Fehler beim Ändern des Passworts",
            "mismatch": "Die Passwörter stimmen nicht überein",
            "tooShort": "Das Passwort ist nicht lang genug"
        }
    },
    "filter": {
        "chooseFilter": "Filter auswählen",
        "chooseOperator": "Operator auswählen",
        "enterValue": "Wert eingeben",
        "chooseValue": "Wert auswählen",
        "keys": {
            "PLATFORM_NO": "Marktplatz",
            "PRODUCTNAME": "Produktname",
            "PART_NO": "Teilenummer",
            "REFERENCE_NUMBER": "Referenznummer",
            "PRICE": "Preis",
            "RRP": "UVP",
            "DISTRIBUTION_PICKUP": "Abholung",
            "DISTRIBUTION_SHIPPING": "Versand",
            "DISTRIBUTION_MOUNTING": "Montage",
            "RRP_PRICE_PARITY": "Preis gleich UVP",
            "CUSTOM_LABOUR_VALUE": "Arbeitswert (individuell)",
            "CATALOG_LABOUR_VALUE": "Arbeitswert",
            "CARLINE_NO": "Fahrzeuge",
            "CATEGORY_NO": "Kategorie"
        },
        "operator": {
            "IS": "= gleich",
            "LIKE": "% enthält",
            "GTE": ">= mindestens",
            "LTE": "<= höchstens",
            "EMPTY": "fehlt",
            "IN": "= verfügbar in",
            "NIN": "!= nicht verfügbar in"
        },
        "operatorLong": {
            "IS": "=",
            "LIKE": "enthält",
            "GTE": "≥",
            "LTE": "≤",
            "EMPTY": "fehlt",
            "IN": "=",
            "NIN": "≠"
        },
        "values": {
            "": "",
            "true": "Ja",
            "false": "Nein",
            "hpm-guid": "Zubehör-Navigator",
            "google-shopping-guid": "Google Shopping"
        }
    },
    "order": {
        "errorNoOrderNo": "Keine Bestellnummer angegeben"
    },
    "orders": {
        "referenceNumber": "Bestell-Nr.",
        "search": "Suche nach Bestell-Nr., Händler-Nr. oder Kunden E-Mail",
        "createAfter": "Zeige Bestellungen ab (Datum)",
        "filterApply": "Filter anwenden",
        "filterReset": "Filter zurücksetzen",
        "export": "Als XLSX exportieren",
        "orderDate": "Bestelldatum",
        "garage": "Autohaus",
        "shippingOptions": "Versandoptionen",
        "totalAmount": "Gesamtbetrag",
        "status": "Bestellstatus",
        "items": "Positionen",
        "orderState": {
            "placed": "Warenkorb gefüllt",
            "approved": "Genehmigt",
            "authorized": "Autorisiert",
            "confirmed": "Bestellt",
            "debited": "Bezahlt",
            "closed": "Geschlossen",
            "paymentFailed": "Zahlung fehlgeschlagen",
            "paymentReset": "",
            "accepted": "",
            "revoked": "Widerrufen",
            "canceled": "Storniert"
        },
        "paymentFailedNotice": "Einzug der Zahlung nach Checkout fehlgeschlagen",
        "paymentFailedDescription": "Achtung: der Kunde hat den Checkout komplett durchlaufen und aus seiner Sicht erfolgreich abgeschlossen. Beim späteren Einzug der Zahlung ist ein Fehler aufgetreten.",
        "revokedNotice": "Bestellung wurde vom Kunden widerrufen.",
        "title": "Bestelldetails",
        "orderInformation": "Bestellinformationen",
        "administration": "Verwaltung",
        "itemOverview": "Artikelübersicht",
        "paymentProvider": "Zahlungsanbieter",
        "paymentProviders": {
            "unset": "Nicht gesetzt",
            "paypal": "PayPal",
            "paypal-express": "PayPal Express",
            "paypal-capture": "PayPal Capture",
            "cash": "Barzahlung",
            "psa-payment-solution": "PSA Payment Solution",
            "psa-sale-ov": "PSA Sale OV",
            "prepaid": "Vorkasse",
            "stripe": "Stripe",
            "gratis": "Gratissendung"
        },
        "customerContact": "Kontaktdaten Kunde",
        "vehicle": "Fahrzeug",
        "customerName": "Kundenname",
        "customerMail": "Kunden-E-Mail",
        "customerPhone": "Kunden-Telefon",
        "address": {
            "billing": "Rechnungsadresse",
            "shipping": "Lieferadresse",
            "pickup": "Abholstandort"
        },
        "licensePlate": "Kennzeichen",
        "vin": "Fahrgestellnummer",
        "garageName": "Autohaus-Name",
        "comment": "Hinweise zum Auftrag",
        "controlNote": "Interne Notiz",
        "itemName": "Artikelname",
        "itemQuantity": "Artikelmenge",
        "itemPrice": "Artikelpreis",
        "itemMountingCosts": "Montage",
        "itemTotalPrice": "Gesamtpreis Position",
        "productNo": "Teilenummer",
        "subTotal": "Zwischensumme",
        "coupon": "Rabattcode",
        "shippingCosts": "Versandkosten",
        "mountingCostsSum": "Montagekosten",
        "plusShipping": "Zzgl. Versand",
        "segmentTotal": "Segment Gesamt",
        "grandTotal": "Gesamtbetrag",
        "segmentType": {
            "pickup": "Abholung",
            "shipping": "Versand",
            "mounting": "Montage"
        },
        "saveChanges": "Änderungen speichern",
        "saveSuccess": "Änderungen erfolgreich gespeichert",
        "saveError": "Fehler beim Speichern der Änderungen",
        "cancelOrder": "Bestellung stornieren",
        "cancelSuccess": "Bestellung erfolgreich storniert",
        "cancelError": "Fehler beim Stornieren der Bestellung",
        "cancelConfirm": {
            "title": "Bestellung stornieren?",
            "message": "Möchten Sie diese Bestellung wirklich stornieren? Der Vorgang ist endgültig und kann nicht rückgängig gemacht werden.\n\nHinweis: Der Kunde wird hierüber nicht automatisch benachrichtigt. Bitte informieren Sie ihn bei Bedarf separat.",
            "confirm": "Jetzt stornieren"
        },
        "revocation": {
            "title": "Informationen zum Widerruf vom {{revocationDate}}",
            "name": "Kundenname",
            "email": "Kunden-E-Mail",
            "reason": "Widerrufsgrund"
        }
    },
    "unit": {
        "piece": "Stück"
    },
    "language": {
        "de": "Deutsch",
        "en": "Englisch"
    },
    "coupons": {
        "title": "Rabattcode Details",
        "create": "Rabattcode erstellen",
        "search": "Rabattcode suchen",
        "filterApply": "Filter anwenden",
        "filterReset": "Filter zurücksetzen",
        "couponNo": "Rabattcode-Nr.",
        "description": "Beschreibung",
        "code": "Code",
        "type": "Typ",
        "discount": "Rabatt",
        "usedContingent": "Verwendet / Gesamt",
        "activeLabel": "Aktiv",
        "contingentLimitation": "Nutzungslimit",
        "contingentLimitationHelp": "0 = unbegrenzte Nutzung",
        "validFrom": "Gültig ab",
        "validUntil": "Gültig bis",
        "minimumOrderAmount": "Mindestbestellwert",
        "excludeDiscounted": "Bereits rabattierte Artikel werden von diesem Gutschein ausgeschlossen",
        "couponInformation": "Rabattcode Informationen",
        "usageInformation": "Nutzungsinformationen",
        "noValidUntil": "Kein Ablaufdatum",
        "noMinimumOrderAmount": "Kein Mindestbestellwert",
        "noUsageInfoForNewCoupon": "Nutzungsinformationen sind nach der Erstellung des Rabattcodes verfügbar.",
        "saveChanges": "Änderungen speichern",
        "createSuccess": "Rabattcode erfolgreich erstellt",
        "saveSuccess": "Rabattcode erfolgreich gespeichert",
        "noShopHint": "Sie haben noch keinen aktiven Shop, daher können Sie keine Rabattcodes anlegen. Kontaktieren Sie uns, wenn Sie Interesse an einem Shop haben.",
        "createError": "Fehler beim Erstellen des Rabattcodes",
        "saveError": "Fehler beim Speichern des Rabattcodes",
        "validation": {
            "description": "Bitte eine Beschreibung eingeben",
            "code": "Bitte einen Rabattcode eingeben",
            "type": "Bitte einen Rabattcode-Typ auswählen",
            "discountValue": "Bitte einen Rabattwert eingeben",
            "contingentLimitation": "Bitte ein Nutzungslimit eingeben",
            "validFrom": "Bitte ein Gültig-ab-Datum eingeben",
            "minimumOrderAmount": "Bitte einen Mindestbestellwert eingeben",
            "discountValuePositive": "Der Rabattwert muss positiv sein",
            "contingentLimitationPositive": "Das Nutzungslimit muss positiv sein",
            "validUntilAfterValidFrom": "Das Gültig-bis-Datum muss nach dem Gültig-ab-Datum liegen",
            "minimumOrderAmountPositive": "Der Mindestbestellwert muss positiv sein",
            "discountValueMaxPercentage": "Der Rabattwert darf maximal 100% betragen",
            "codeMinLength": "Der Code muss mindestens 4 Zeichen haben",
            "formHasErrors": "Bitte beheben Sie die Fehler im Formular, bevor Sie fortfahren."
        },
        "active": {
            "yes": "Ja",
            "no": "Nein"
        }
    },
    "coupon": {
        "errorNoGarage": "Kein Autohaus ausgewählt. Bitte wählen Sie ein Autohaus aus, um Rabattcode anzuzeigen.",
        "type": {
            "PERCENTAGE": "Prozentual",
            "FIXED_VALUE": "Fester Betrag"
        }
    },
    "customerAnalytics": {
        "title": "Kundenanalyse",
        "topProductCategories": "Meistgeklickte Produktkategorien",
        "topVehicleModels": "Meistgeklickte Fahrzeugmodelle",
        "topProducts": "Meistgeklickte Produkte",
        "customerLeadsEvents": "Nutzerverhalten und Leads",
        "dailyPlatformUsageRatio": "Plattformaktivität im 30-Tage-Trend",
        "events": {
            "visits": "Produkt angeklickt",
            "addedToCart": "Einkaufswagen gefüllt",
            "ordered": "Produkt bestellt",
            "bookmarked": "Produkt zu den Favoriten hinzugefügt",
            "shared": "Produkt empfohlen",
            "enquiries": "Frage zum Produkt"
        }
    },
    "dashboard": {
        "title": "Dashboard",
        "ecommerce": "E-Commerce",
        "selectBrand": "Marke auswählen",
        "count": "Anzahl",
        "overview": {
            "title": "Übersicht",
            "greetings": {
                "morning": "Guten Morgen",
                "afternoon": "Guten Tag",
                "evening": "Guten Abend"
            },
            "welcome": {
                "title": "Willkommen zurück in Ihrem Dashboard. Hier sehen Sie, was momentan in Ihrem Unternehmen passiert.",
                "subtitle1": "Verschaffen Sie sich einen Überblick über Ihre wichtigsten Kennzahlen und Einblicke, um jederzeit über Ihre aktuelle Performance informiert zu bleiben.",
                "subtitle2": "Ihre zentralen Kennzahlen und Analysen finden Sie unten – bleiben Sie jederzeit über Ihre Leistung auf dem Laufenden.",
                "subtitle3": "Nutzen Sie die folgenden Einblicke und Kennzahlen, um Ihre Performance gezielt im Blick zu behalten.",
                "subtitle4": "Hier finden Sie Ihre relevanten Kennzahlen und Einblicke, damit Sie fundierte Entscheidungen auf Basis aktueller Daten treffen können.",
                "subtitle5": "Starten Sie mit einem klaren Blick: Ihre wichtigsten Kennzahlen und Einblicke zeigen Ihnen, wo Sie stehen und wie Sie noch mehr erreichen können.",
                "subtitle6": "Behalten Sie Ihre Erfolge im Blick – die folgenden Kennzahlen und Analysen unterstützen Sie dabei, Ihr Potenzial voll auszuschöpfen.",
                "subtitle7": "Ihre Leistung im Fokus: Nutzen Sie die Einblicke unten, um Fortschritte sichtbar zu machen und die nächsten Schritte gezielt zu steuern.",
                "subtitle8": "Wer seine Zahlen kennt, gestaltet seinen Erfolg aktiv – werfen Sie einen Blick auf Ihre aktuellen Kennzahlen und Erkenntnisse.",
                "subtitle9": "Behalten Sie Ihre Erfolge im Blick – unsere Analysen unterstützen Sie dabei, Ihr Potenzial voll auszuschöpfen."
            },
            "widgets": {
                "totalViews": "Aufrufe monatlich",
                "avgMonthlyViews": "Durchschnittliche monatliche Aufrufe",
                "trend": "Trend",
                "cartToPurchase": "Konversionsrate (Warenkorb zu Kauf)",
                "sales30Days": "Verkäufe (30 Tage)",
                "revenue30Days": "Umsatz (30 Tage)"
            },
            "trends": {
                "up": "Steigend",
                "down": "Fallend",
                "stable": "Stabil"
            },
            "subtitles": {
                "last7Days": "Letzte 7 Tage: {{count}}",
                "monthlyIncrease": "Monatliche Veränderung: {{percent}}%",
                "last6MonthsAverage": "Durchschnitt der letzten 6 Monate",
                "cartsConverted": "{{purchases}} von {{carts}} Warenkörben"
            },
            "chart": {
                "title": "Aufrufe monatlich (letzte 6 Monate)",
                "estimation": "Schätzung",
                "reality": "Aufrufe"
            },
            "loading": "Übersichtsdaten werden geladen...",
            "error": "Fehler beim Laden der Übersichtsdaten"
        },
        "widgets": {
            "averageCartPrice": "Durchschnittlicher Warenkorbwert",
            "averageArticlesInCart": "Durchschnittliche Artikel im Warenkorb",
            "totalSoldItems": "Verkaufte Artikel gesamt",
            "averageItemsPerPurchase": "Durchschnittliche Artikel pro Kauf",
            "averageCartPriceWithDiscount": "Durchschnittlicher Warenkorbwert mit Rabatt",
            "purchasesWithDiscountCodes": "Käufe mit Rabattcodes",
            "largestSale": "Größter Verkauf",
            "totalRevenueLastMonth": "Gesamtumsatz letzter Monat",
            "currentRevenueCurrentMonth": "Aktueller Umsatz aktueller Monat",
            "estimatedRevenueCurrentMonth": "Geschätzter Umsatz aktueller Monat",
            "revenueVariation": "{{value}} % zum Vormonat"
        },
        "subtitles": {
            "lastSixMonthsAverage": "Durchschnitt der letzten 6 Monate",
            "itemsPerCart": "Artikel pro Warenkorb",
            "lastSixMonthsCumulative": "Kumulativ der letzten 6 Monate",
            "itemsPerCompletedPurchase": "Artikel pro abgeschlossenem Kauf",
            "whenDiscountCodesApplied": "Bei angewendeten Rabattcodes",
            "lastSixMonths": "Letzte 6 Monate",
            "singleLargestTransaction": "Größte Einzeltransaktion"
        },
        "charts": {
            "mostSoldItemsTitle": "Meistverkaufte Artikel - Letzte 6 Monate",
            "clickToFilter": "Klicken Sie auf ein Produkt zum Filtern:",
            "noData": "Für dieses Produkt liegen noch keine Daten vor.",
            "totalSales": "Verkäufe gesamt",
            "numberOfSales": "Anzahl Verkäufe",
            "numberOfClicks": "Anzahl Klicks",
            "totalSalesLabel": "Verkäufe gesamt",
            "totalClicksLabel": "Klicks gesamt",
            "purchaseTypesDistribution": "Verteilung der Kaufarten",
            "salesAndRevenue": "Verkäufe und Umsatz - Letzte 6 Monate + Aktueller Monat",
            "userSources": "Nutzerquellen - Woher kommen die Nutzer",
            "selectUpToThreeSources": "Wählen Sie bis zu 3 Quellen aus:",
            "sources": {
                "qr-mirror": "Spiegelanhänger",
                "qr-sticker": "Sticker",
                "qr-magnet": "Magnetfolie",
                "google-shopping": "Google Shopping",
                "dealer": "Händlerwebsite",
                "central": "Zentrale Vertriebsseiten",
                "vehicle-mailing": "Fahrzeugmailing",
                "mail-campaign": "E-Mail-Kampagne",
                "social-media": "Soziale Medien",
                "mobile-app": "Mobile App",
                "unknown": "Keine Angabe"
            },
            "clearAll": "Alle löschen",
            "total": "Gesamt",
            "revenue": "Umsatz",
            "salesCount": "Verkaufsanzahl",
            "totalRevenue": "Gesamtumsatz",
            "estimatedRevenue": "Geschätzter Umsatz",
            "estimatedSalesCount": "Geschätzte Verkaufsanzahl",
            "revenueShort": "Umsatz",
            "salesCountShort": "Verkaufsanzahl",
            "soFar": "bisher",
            "projected": "prognostiziert",
            "selected": "Ausgewählt",
            "showingOnlyTotal": "nur Gesamt angezeigt"
        },
        "productSettings": "Produkteinstellungen",
        "productPricing": "Produktpreisverteilung",
        "categories": {
            "UNDERMOST": "Deutlich unter UVP",
            "UNDER": "Leicht unter UVP",
            "EQUAL": "Entspricht UVP",
            "OVER": "Leicht über UVP",
            "OVERMOST": "Deutlich über UVP"
        },
        "options": {
            "shipping": "Versand",
            "pickup": "Abholung",
            "mounting": "Montage",
            "mount": "Montage",
            "notForSale": "Nicht verkäuflich",
            "mixed": "Gemischt"
        },
        "storefrontAvailable": "Produktverfügbarkeit",
        "storefrontWarnings": "Warnungen",
        "warnings": {
            "CHECK_ACTIVATIONS": "Es sind zu wenige Produkte (<90%) veröffentlicht.",
            "CHECK_DISTRIBUTION_CHANNEL": "Für viele Produkte (>20%) sind nicht alle Vertriebswege konfiguriert.",
            "USE_GOOGLE_SHOPPING": "Google Shopping ist nicht eingerichtet.",
            "CHECK_GOOGLE_SHOPPING": "Zu wenige Produkte (<10%) werden zu Google Shopping veröffentlicht.",
            "CHECK_BARGAIN_ACTIVATIONS": "Zu wenige Produkte haben einen Angebotspreis."
        },
        "noData": {
            "title": "Für diese Ansicht sind noch keine Daten vorhanden.",
            "hint": "Die Auswertungen entstehen, sobald Besucher Ihre Shops nutzen. Neue Autohäuser sehen hier in den ersten Tagen noch nichts."
        },
        "noPermission": "Ihrer Rolle fehlt das Recht, das Dashboard zu sehen.",
        "contact": {
            "title": "IT-Tecture Support",
            "phone": "+49 (0)381 666989-100",
            "openings": "Mo–Fr 9:00–17:00 Uhr",
            "helpCenter": "Zum Hilfe-Center"
        },
        "recommendationsOk": {
            "title": "Sehr gut",
            "text": "Sie schöpfen Ihr Potential voll aus: Die Produkte sind aktiviert, haben günstige Preise und es stehen verschiedene Versandoptionen zur Verfügung."
        },
        "modules": {
            "WEB": "Homepage-Modul",
            "UCL": "UCL",
            "POS": "Point of Sale",
            "unknown": "Unbekannt"
        }
    },
    "help": {
        "section": {
            "documents": "Dokumente",
            "faq": "FAQ",
            "contact": "Kontakt",
            "videos": "Videos"
        },
        "center": {
            "title": "Hilfe-Center",
            "description": "Willkommen in unserem Hilfe-Center. Finden Sie die Unterstützung, die Sie benötigen, in den folgenden Bereichen.",
            "sections": {
                "documents": {
                    "title": "Dokumente",
                    "description": "Finden Sie alle relevanten Dokumentationen und Anleitungen"
                },
                "videos": {
                    "title": "Videos",
                    "description": "Schauen Sie hilfreiche Tutorial-Videos und Demonstrationen"
                },
                "faq": {
                    "title": "FAQ",
                    "description": "Erhalten Sie Antworten auf häufig gestellte Fragen"
                },
                "enquiry": {
                    "title": "Support-Anfrage",
                    "description": "Senden Sie Ihre Fragen an unser Support-Team"
                }
            }
        },
        "enquiry": {
            "success": "Ihre Anfrage wurde erfolgreich gesendet. Wir werden uns so schnell wie möglich bei Ihnen melden.",
            "confirmationTitle": "Vielen Dank für Ihre Anfrage!",
            "error": "Beim Senden Ihrer Anfrage ist ein Fehler aufgetreten.",
            "formTitle": "Kontaktformular",
            "description": "Willkommen im Bereich Support-Anfrage. Bitte füllen Sie das untenstehende Formular aus und unser Team wird sich bei Ihnen melden.",
            "fields": {
                "subject": {
                    "label": "Betreff",
                    "required": "Betreff ist erforderlich"
                },
                "phone": {
                    "label": "Rückruf-Nummer",
                    "required": "Rückruf-Nummer ist erforderlich"
                },
                "message": {
                    "label": "Nachricht",
                    "required": "Nachricht ist erforderlich"
                }
            },
            "submit": "Anfrage senden",
            "submitting": "Anfrage wird gesendet …"
        },
        "faq": {
            "heading": {
                "web-module": "Webmodul & Webshop",
                "qr": "QR-Codes",
                "management": "Verwaltungsoberfläche & Produktkataloge",
                "google": "Google Shopping"
            },
            "question": {
                "web-module-1": "Was muss ich tun um das Webmodul oder den Webshop auf meiner Seite zu integrieren?",
                "web-module-2": "Muss ich bei Änderungen immer ein neues Modul in meine Website einbauen?",
                "web-module-3": "Ich nutze ein CMS (bspw. Wordpress) für die Erstellung meiner Website. Funktioniert der Zubehör-Navigator auch damit?",
                "web-module-4": "Wie müssen URLs aussehen, damit sie im Dashboard \"Herkunft der Nutzer / Vertriebskanäle\" richtig gezählt werden?",
                "qr-1": "Wohin führen die QR-Codes?",
                "qr-2": "Wo kann ich QR-Code-Magnetfolien nachbestellen?",
                "qr-3": "Kann ich den QR-Code-Spiegelanhänger selbst drucken lassen?",
                "qr-4": "Kann ich den QR-Code vom Spiegelanhänger auch woanders nutzen?",
                "management-1": "Sind Preisanpassungen für das Zubehör möglich?",
                "management-2": "Was passiert, wenn die Produktpreise sich ändern",
                "management-3": "Was passiert, wenn Artikel nicht mehr lieferbar sind?",
                "management-4": "Wie kann ich meinen Erfolg messen?",
                "management-5": "Wie ändere ich meinen Stundenverrechnungssatz?",
                "google-1": "Was ist Google Shopping?",
                "google-2": "Warum funktioniert dieses Format so gut?",
                "google-3": "Was sind die Vorteile von Google Shopping?",
                "google-4": "Wie funktioniert Google Shopping für den Zubehör-Navigator?",
                "google-5": "Wie kann ich bei Google Shopping teilnehmen?"
            },
            "answer": {
                "web-module-1": "Unser Webmodul und der Webshop lassen sich ganz einfach auf jeder Website mit Hilfe eines von uns gelieferten JavaScript Codes einbetten. Der Einbau sollte auch unerfahrenen Nutzern innerhalb von 15 Minuten leicht von der Hand gehen.",
                "web-module-2": "Nein, alle Änderungen erfolgen in unserer Verwaltungsoberfläche. Die Integration auf Ihrer Website nehmen Sie nur einmal vor.",
                "web-module-3": "Ja, auch in die bekannten CMS Systeme lässt sich der Zubehör-Navigator einfach integrieren. Eine Anleitung und Hilfe bekommen Sie von unserem Support-Team.",
                "web-module-4": "Wenn Sie URLs z.B. in E-Mails oder Social Media herausgeben, dann müssen Sie den folgenden Parameter an die URL hängen: https://www.ihre-website.de/shop?<b>utm_medium=XXXXX</b> wobei XXXXX hierbei z.B. \"mail-campaign\" für eine Newsletter-Kampagne, \"social-media\" für Links aus Social-Media-Plattformen oder \"dealer\" für Links auf Ihre Händler-Website sein kann. Die vollständige Liste der unterstützten Parameter finden Sie in der Einbauanleitung für das Webmodul.",
                "qr-1": "Die QR-Codes stehen auf den Magnetfolien und den Spiegelanhängern und führen immer zum Zubehör-Navigator auf Ihrer Partnerwebsite, sodass der Kunde sofort Ihre Zubehör-Produkte auf seinem Smartphone sieht. \n\nAber es gibt Unterschiede:\n<ul>\n<li>Die <b>QR-Code-Magnetfolien</b> werden am Fahrzeug angebracht und sind daher modellspezifisch. Es werden nur die Produkte angezeigt, die in das jeweilige Fahrzeug passen.</li>\n<li>Der QR-Code auf den <b>Spiegelanhängern</b> ist unabhängig vom Fahrzeugmodell, d.h. alle Produkte werden gezeigt. Er führt direkt in den Zubehör-Navigator Ihres Autohauses. Sie entscheiden bei der Einrichtung, ob sich dieser auf Ihrer eigenen Website befindet oder auf der Seite des Herstellers. Der QR-Code wird also in jedem Fall individuell für Ihren Standort erstellt.</li>\n<li>Der QR-Code auf der Stickerrolle ist unabhängig vom Fahrzeugmodell und funktioniert wie der QR-Code auf den Spiegelanhängern.</li>\n</ul>",
                "qr-2": "Sollten die zum Start bereitgestellten QR-Code-Magnetfolien aus dem Start-Set nicht ausreichen, so können Sie eine Nachbestellung aufgeben. Entweder wünschen Sie wieder ein komplettes Start-Set oder einzelne Fahrzeugmodell-Sticker in gewünschter Stückzahl. Bitte <a href=\"enquiry\" style=\"text-decoration:underline\" >rufen Sie uns an oder schreiben Sie eine E-Mail.</a>",
                "qr-3": "Sie können jederzeit mit dem PDF-Dokument zum Download den Druck selbst veranlassen – in beliebiger Auflage und in einer Druckerei Ihrer Wahl.",
                "qr-4": "Es ist naheliegend, dass Sie den QR-Code Ihres Zubehör-Navigators auch in anderen Medien verwenden, beispielsweise auf Ihrem Briefpapier, auf Rechnungen oder auf Visitenkarten. So erreichen Sie noch mehr Ihrer Kunden. Daran haben wir auch schon gedacht und bieten Ihnen den QR-Code als hochaufgelöste Grafikdatei zum Download an.",
                "management-1": "Ja, das ist sogar einer der wesentlichen Vorteile des Zubehör-Navigators. Sie haben die Möglichkeit, die Produktpreise jederzeit anzupassen. Dafür stellen wir Ihnen die UPE zur Verfügung, sodass prozentuale Anpassungen des Materialpreises nach oben oder unten möglich sind. Sie können dies für das gesamte Sortiment, ausgewählte Produktgruppen oder sogar einzelne Produkte machen. Zudem stehen Ihnen die Arbeitswerte für die Produkte zur Verfügung, die eine Montage erfordern. Mit Hilfe Ihres Stundenverrechnungssatzes können Sie dann die Einbaukosten kalkulieren und somit Ihren Kunden Komplettpreise Material inkl. Einbau anbieten",
                "management-2": "Sollte es zu Anpassungen der UPE durch einen der Hersteller in Deutschland kommen, sind wir die ersten, die davon erfahren. Wir stellen Ihnen die aktualisierten UPE nicht nur in den Katalogen zur Verfügung, sondern können auch – sofern Sie das wünschen – Ihre individualisierten Produktpreise automatisch neu berechnen und somit auf den neuesten Stand bringen. Dafür nutzen wir die Preisregeln, die Sie zuvor bei der Preisindividualisierung festgelegt haben (siehe nächste Frage). Für Sie bedeutet dies eine stressfreie Preispflege und deutlich weniger Aufwand.",
                "management-3": "Sollte ein Artikel seitens eines Herstellers nicht mehr lieferbar sein (ausgelaufen oder inaktiv), so wird er solange aus dem Katalog genommen. Ihre Kunden finden ihn dann also nicht mehr. Sollten Sie einen Tarif mit dem Web-Shop gebucht haben, so können Sie aber einen lokalen Lagerbestand pflegen, sodass in Ihrem Shop solche Artikel dennoch weiterhin angeboten werden, sofern Sie diese noch auf Lager haben.",
                "management-4": "In der Verwaltungsoberfläche können Sie tagesaktuell Ihren Erfolg sehen. Unser Dashboard zeigt Ihnen alle wichtigen Daten zu Ihrem Zubehör-Navigator an. Beispielsweise: Anzahl der Besucher, Umsätze, Meist geklickte Kategorien, Produkteinstellungen und vieles mehr",
                "management-5": "Den SVS können Sie unter dem Menüpunkt \"Mein Autohaus\" ändern. Diesen können Sie unten auf der Seite für jede Marke individuell anpassen, wenn Sie auf \"Bearbeiten\" klicken.",
                "google-1": "Google Shopping richtet sich explizit an kaufbereite Kunden, die online auf der Suche nach bestimmten Produkten sind. Bei Google gibt es hierfür eine separate Suchkategorie, auf der Nutzer sich nach Produkten umschauen können. Darüber hinaus spielt Google außerdem Anzeigen parallel zu den Suchergebnissen einer „normalen“ Google-Suche aus, sofern diese sich auf ein kaufbares Produkt bezieht.",
                "google-2": "Shopping richtet sich ausschließlich an Nutzer, die bereit sind, etwas zu kaufen. Der Nutzer sieht auf einen Blick ein Bild des Artikels, den Preis, eine kurze Beschreibung und Informationen über den Versand. Google macht es ihnen also sehr leicht, Käufe zu tätigen, sowie Produkte und Angebote bei verschiedenen Online-Shops zu vergleichen, ohne sich durch alle Seiten klicken zu müssen. Kurzum: Wer bei Shopping sucht, will etwas kaufen.",
                "google-3": "Google Shopping richtet sich besonders zielgerichtet an potenzielle Kunden. Der Nutzer weiß schon recht genau was er will. Der Streuverlust ist bei diesen Anzeigen im Vergleich zu anderen also sehr gering. Google Shopping Anzeigen punkten mit Relevanz. Dies führt zu ausgezeichneten Konversionsraten. Ein Verwaltungsaufwand ist praktisch nicht vorhanden. Sie haben die volle Kontrolle über Ihre Kosten. Die Nutzung von Shopping führt zu mehr Website-Aufrufen und einem höheren Bewusstsein für Ihr Autohaus und Ihre Website.\n\t",
                "google-4": "Der Zubehör-Navigator liefert Ihnen bereits ein breit gefächertes und spezifisches Produktsortiment. Die Anzeigen werden von uns automatisch aus den Produkten aus Ihrem Zubehör-Navigator erstellt. Sie zahlen nur, wenn Nutzer auf Ihre Anzeige klicken und daraufhin auf Ihre Website gelangen. Sie entscheiden welche Ihrer Produkte bei Google Shopping zu finden sein sollen.",
                "google-5": "Bitte kontaktieren Sie unser Support-Team, um Google Shopping für Ihren Zubehör-Navigator zu aktivieren. Wir helfen Ihnen gerne weiter."
            }
        }
    },
    "settings": {
        "emailTemplates": {
            "description": "Passen Sie die Kundenmails Ihres Betriebs an: Akzentfarbe und Kopfbild je Marke.",
            "appearance": "Darstellung",
            "template": "E-Mail",
            "templateOrder": "Bestellbestätigung",
            "templateEnquiry": "Produktanfrage",
            "templateWishlist": "Favoriten",
            "templateGarageOrder": "Bestelleingang (Betrieb)",
            "templateGarageEnquiry": "Produktanfrage (Betrieb)",
            "templateGarageWishlist": "Favoriten (Betrieb)",
            "templateRevocationCustomer": "Widerruf",
            "templateRevocationCustomerAnonymous": "Widerruf ohne Bestellung",
            "templateRevocationGarage": "Widerruf (Betrieb)",
            "templateRevocationGarageAnonymous": "Widerruf ohne Bestellung (Betrieb)",
            "templateUpcomingHandover": "Mailer Fahrzeugverkauf: Vorfreude Mail",
            "templatePastHandover": "Mailer Fahrzeugverkauf: Abschluss Mail",
            "templateSaleContracted": "Mailer Fahrzeugverkauf: Willkommen Mail",
            "templateAccountActivation": "Konto aktivieren",
            "templateAccountPasswordReset": "Passwort zurücksetzen",
            "templateDormantWarning": "Konto: Hinweis auf Inaktivität",
            "templateDormantInactivation": "Konto: Deaktivierung",
            "templateContractSignedCustomer": "Vertrag unterschrieben",
            "templateContractSignedBusiness": "Vertrag unterschrieben (intern)",
            "templateSmtpConfirmation": "Mailserver bestätigt",
            "templateSmtpTest": "Mailserver-Testmail",
            "templateSmtpFailure": "Mailserver nicht erreichbar",
            "templateHelpDesk": "Support-Anfrage (intern)",
            "templateDeadLetter": "Unzustellbare Mail (intern)",
            "brand": "Marke",
            "accentColor": "Akzentfarbe",
            "accentHex": "Farbwert",
            "accentPick": "Akzentfarbe wählen",
            "accentArea": "Sättigung und Helligkeit",
            "accentHue": "Farbton",
            "accentNoHex": "Bitte eine Farbe als Hex-Wert angeben, zum Beispiel #EC0000.",
            "accentCustom": "individuell",
            "uploadHeroImage": "Header Bild hochladen",
            "heroImage": "Header-Bild",
            "chooseHeroImage": "Bild wählen",
            "heroImageActive": "eigenes Bild aktiv",
            "heroImageInfo": "Das Header-Bild ist das Kopfbild oben in jeder Kundenmail. PNG oder JPEG, empfohlen bis {{warn}}. Bilder breiter als {{scaleWidth}} Pixel werden automatisch auf die Mailbreite verkleinert.",
            "heroImageInfoLabel": "Erklärung zum Header-Bild",
            "brandSwitchMessage": "Sie haben ungespeicherte Änderungen. Möchten Sie die Marke trotzdem wechseln?",
            "brandSwitchConfirm": "Marke wechseln",
            "preview": "Vorschau",
            "subjectLabel": "Betreff",
            "previewHint": "Vorschau mit Beispieldaten, dargestellt wie die echte Mail. Farbe und Bild gelten für alle Kundenmails.",
            "previewMailReceiver": "Empfänger der Vorschau",
            "sendPreviewMail": "Vorschau als Mail senden",
            "sendPreviewMailConfirm": "Senden",
            "previewMailHint": "Sendet die in der Vorschau gewählte Mail mit Beispieldaten an diese Adresse – mit dem aktuell eingestellten Stand, auch wenn er noch nicht gespeichert ist.",
            "previewMailSent": "Vorschau an {{receiver}} gesendet.",
            "previewMailFailed": "Die Vorschau konnte nicht gesendet werden.",
            "descriptionGroup": "Passen Sie die E-Mails Ihrer Gruppe an. Sie können die Akzentfarbe und das Kopfbild je Marke anpassen.",
            "accentInherited": "Standard",
            "heroImageChosen": "neues Bild gewählt",
            "heroImageInherited": "Standard",
            "loadFailed": "Die Einstellungen konnten nicht geladen werden.",
            "saveFailed": "Die Einstellungen konnten nicht gespeichert werden.",
            "previewFailed": "Die Vorschau kann nicht angezeigt werden.",
            "previewLinkDisabled": "Links funktionieren in der Vorschau nicht.",
            "imageTypeRejected": "Nur PNG und JPEG sind möglich.",
            "imageTooLarge": "Das Bild ist zu groß, maximal {{max}}.",
            "imageLarge": "Das Bild ist größer als die empfohlenen {{warn}}. Speichern ist möglich, es verlängert aber die Ladezeit jeder Kundenmail.",
            "imagePixelsTooLarge": "Das Bild ist mit {{width}} × {{height}} Pixeln zu groß, maximal {{maxWidth}} × {{maxHeight}} Pixel.",
            "imageWillBeScaled": "Das Bild ist mit {{width}} × {{height}} Pixeln breiter als die Mailbreite und wird beim Speichern automatisch auf {{scaleWidth}} Pixel Breite verkleinert.",
            "imageScaled": "Das Bild wurde von {{width}} × {{height}} Pixeln auf {{scaleWidth}} Pixel Breite verkleinert.",
            "imageUploadTooLarge": "Das Bild konnte nicht hochgeladen werden, es ist zu groß.",
            "imageRejected": "Das Bild konnte nicht verwendet werden. Bitte wählen Sie ein anderes Bild.",
            "previewStale": "Die Vorschau ist nicht aktuell, die letzte Änderung konnte nicht dargestellt werden.",
            "previewRetry": "Vorschau erneut laden",
            "saveSuccess": "Die Einstellungen wurden gespeichert.",
            "imageStoredTooLarge": "Das Bild ist auch verkleinert noch größer als {{max}}. Bitte wählen Sie ein anderes Bild oder speichern Sie es stärker komprimiert."
        },
        "mailServer": {
            "host": "SMTP-Host",
            "port": "Port",
            "encryption": "Verschlüsselung",
            "encryptionNone": "Keine",
            "encryptionStartTlsHint": "STARTTLS ist weiterhin nutzbar, gilt aber nicht mehr als sicher. Wählen Sie SSL/TLS, wenn Ihr Server es anbietet.",
            "encryptionNoneHint": "Diese Einstellung stammt aus der Zeit vor der Verschlüsselungspflicht. Ohne SSL/TLS oder STARTTLS lässt sie sich nicht mehr speichern – die Mails enthalten personenbezogene Daten Ihrer Kunden.",
            "username": "Benutzername",
            "password": "Passwort",
            "passwordUnchanged": "unverändert",
            "senderName": "Absendername",
            "senderAddress": "Absenderadresse",
            "saved": "Einstellungen gespeichert",
            "readOnlyInSupportContext": "Im Support-Kontext ist der Mail-Versand nur lesbar. Einrichten und ändern kann ihn nur der Kunde selbst.",
            "saveFailed": "Die Einstellungen konnten nicht gespeichert werden.",
            "loadFailed": "Die Einstellungen konnten nicht geladen werden.",
            "discardBack": "Zurück",
            "discardConfirm": "Verwerfen",
            "discardTitle": "Änderungen verwerfen",
            "discardConfirmToActive": "Hiermit verwerfen Sie alle Eingaben und kehren zu Ihrer zuletzt gespeicherten Konfiguration zurück. Am Mailversand ändert sich dadurch nichts.",
            "discarded": "Änderungen verworfen",
            "discardFailed": "Die Änderungen konnten nicht verworfen werden.",
            "removeTitle": "Eigenen Mailserver nicht mehr nutzen",
            "removeConfirm": "Nicht mehr nutzen",
            "removeConfirmGarage": "Alle Mails gehen danach wieder über den Standard-Mailserver des Zubehör-Navigators.\nIhre Einstellungen werden unwiderruflich gelöscht, zum Reaktivieren müssen Sie den Server erneut einrichten.",
            "removeConfirmGroup": "Ihre Betriebe versenden danach wieder über den Standard-Mailserver des Zubehör-Navigators, soweit sie keinen eigenen Mailserver haben. Wir löschen dabei Ihre gespeicherten Einstellungen und eine noch nicht aktivierte Änderung. Das wirkt sofort und lässt sich nur durch eine neue Einrichtung rückgängig machen.",
            "removed": "Wir versenden nicht mehr über Ihren Mailserver.",
            "removeFailed": "Ihre Mailserver-Einstellungen konnten nicht gelöscht werden.",
            "retry": "Erneut versuchen",
            "retryFailed": "Der erneute Versuch konnte nicht gestartet werden.",
            "activationReceiver": "Code senden an",
            "sendActivationMail": "Code senden",
            "resendActivationMail": "Neuen Code anfordern",
            "resendActivationMailIn": "Neuer Code in {{seconds}} s",
            "resendWait": "Bitte {{seconds}} s warten",
            "activationMailSent": "Code verschickt",
            "activationMailFailed": "Der Code konnte nicht versendet werden.",
            "saveReplacesCode": "Bitte speichern Sie Ihre Änderungen. Danach fordern Sie einen neuen Code an – der aus der vorherigen Mail funktioniert dann nicht mehr.",
            "activationCode": "Aktivierungscode",
            "activate": "Aktivieren",
            "activationFailed": "Die Aktivierung ist fehlgeschlagen.",
            "activationActivated": "Mailserver aktiviert",
            "activationNoCandidate": "Es liegt keine ausstehende Änderung zur Aktivierung vor.",
            "activationInvalidCode": "Der eingegebene Code ist nicht korrekt.",
            "activationExpired": "Der Code ist abgelaufen. Bitte senden Sie einen neuen.",
            "activationTooManyAttempts": "Zu viele Fehlversuche. Bitte senden Sie einen neuen Code.",
            "remainingAttempts": "Verbleibende Versuche: {{count}}",
            "bannerFailing": "Ihr Mailserver ist evtl. nicht erreichbar. Bitte prüfen Sie Ihre Mail-Einstellungen.",
            "bannerDeactivated": "Ihr Mailserver ist nicht erreichbar! Bitte prüfen Sie Ihre Mail-Einstellungen!",
            "bannerAction": "Prüfen",
            "attentionRequired": "Handlungsbedarf beim Mail-Versand",
            "failureFromCheck": "regelmäßige Prüfung",
            "failureFromTestMail": "Testmail",
            "failureFromSend": "Versand einer Kundenmail",
            "testMail": "Testmail",
            "testMailHelp": "Sie können jederzeit eine Testmail über Ihren aktiven Mailserver verschicken, zum Beispiel nachdem sich an Ihrer IT etwas geändert hat. An Ihrer Konfiguration ändert sich dadurch nichts.",
            "testMailReceiver": "Testmail senden an",
            "sendTestMail": "Testmail senden",
            "testMailSent": "Testmail versendet",
            "testMailFailed": "Die Testmail konnte nicht versendet werden.",
            "statusReasonNone": "Keine Auffälligkeiten.",
            "rejectedNeedsUsername": "Bitte tragen Sie den Benutzernamen ein, mit dem sich der Mailserver anmeldet.",
            "rejectedNeedsPassword": "Bitte tragen Sie das Passwort ein – bei der ersten Einrichtung gibt es keines zu übernehmen.",
            "rejectedNeedsEncryption": "Ein Mailserver ohne Transportverschlüsselung wird nicht gespeichert. Bitte wählen Sie SSL/TLS oder STARTTLS.",
            "rejectedNothingToRetry": "Der Versand über Ihren Mailserver ist nicht pausiert, es gibt nichts erneut zu prüfen.",
            "rejectedNoCandidate": "Es liegt keine ausstehende Änderung vor. Bitte speichern Sie Ihre Einstellungen erneut.",
            "rejectedNoVerifiedServer": "Sie haben derzeit keinen eigenen Mailserver im Versand, der sich testen ließe.",
            "rejectedNoSendingServer": "Es ist kein Mailserver verfügbar, über den die Mail versendet werden könnte.",
            "statusReasonAuth": "Der Server hat Benutzernamen oder Passwort abgelehnt.",
            "statusReasonMessaging": "Der Server war unter dem eingetragenen Host und Port nicht erreichbar.",
            "statusReasonOther": "Die Verbindung ist aus einem unerwarteten Grund fehlgeschlagen.",
            "routesIntro": "Wählen Sie, über welchen Weg E-Mails an Ihre Kunden verschickt werden.",
            "fallbackPlatform": "Standard-Mailserver",
            "fallbackGroup": "Mailserver Ihrer Gruppe",
            "sendingVia": "Versand über:",
            "ownServerOffer": "Mails an Ihre Kunden kommen von Ihrer eigenen Adresse.",
            "pillActive": "Aktiv",
            "pillActiveUntilCode": "noch Aktiv – bis Eigener Mailserver eingerichtet ist",
            "pillActiveUntilRepaired": "Aktiv, bis Ihr Server wieder funktioniert",
            "pillStandby": "Springt bei Fehlern ein",
            "pillWaitingForCode": "Wartet auf Code",
            "pillCodeSent": "Code verschickt",
            "pillActivePrevious": "Aktiv mit bisherigen Einstellungen",
            "pillChangeWaiting": "Änderung wartet auf Code",
            "pillFailing": "{{count}} von {{of}} Versuchen fehlgeschlagen",
            "pillDeactivated": "Abgeschaltet",
            "failingDetail": "{{reason}} Wir versenden weiter über Ihren Mailserver. Schlagen {{of}} Versuche (Prüfung oder Versand) in Folge fehl, versenden wir über den Standard-Mailserver, es geht keine Mail verloren.",
            "deactivatedDetail": "{{of}} Versuche in Folge fehlgeschlagen. {{reason}} Mails an Ihre Kunden gehen so lange über den Standard-Mailserver, es geht keine Mail verloren.",
            "deactivatedAtOnce": "Beim Versand einer Kundenmail hat Ihr Server einen Fehler gemeldet. {{reason}} Mails an Ihre Kunden gehen so lange über den Standard-Mailserver, es geht keine Mail verloren.",
            "newSettings": "Neu: {{line}}",
            "setUp": "Einrichten",
            "enterCode": "Code eingeben",
            "edit": "Bearbeiten",
            "checkSettings": "Einstellungen prüfen",
            "useFallbackPlatform": "Standard-Mailserver verwenden",
            "useFallbackGroup": "Mailserver der Gruppe verwenden",
            "discardChange": "Änderung verwerfen",
            "cancelSetupTitle": "Einrichtung abbrechen",
            "cancelSetupMessage": "Wir löschen dabei Ihre gespeicherten Einstellungen für den eigenen Mailserver, ein verschickter Code verfällt. Mails an Ihre Kunden gehen weiter wie bisher. Möchten Sie später über Ihren eigenen Mailserver versenden, richten Sie ihn neu ein.",
            "cancelSetupConfirm": "Einstellungen löschen",
            "setupCancelled": "Einrichtung abgebrochen",
            "stepSettings": "Einstellungen",
            "stepSendCode": "Code senden",
            "stepEnterCode": "Code eingeben",
            "saveAndContinue": "Speichern und weiter",
            "continue": "Weiter",
            "back": "Zurück",
            "sendCodeHelp": "Wir schicken einen Zahlencode über die eben gespeicherten Einstellungen. Kommt er an, funktioniert Ihr Mailserver. Bis dahin bleibt der Versand, wie er ist.",
            "enterCodeHelp": "Geben Sie den Code aus der Mail an {{receiver}} ein. Er gilt {{hours}} Stunden. Ändern Sie die Einstellungen vorher noch einmal, brauchen Sie einen neuen Code.",
            "enterCodeHelpNoReceiver": "Geben Sie den Code aus der Mail ein, die wir Ihnen geschickt haben. Er gilt {{hours}} Stunden. Ändern Sie die Einstellungen vorher noch einmal, brauchen Sie einen neuen Code.",
            "noMailReceived": "Keine Mail erhalten?",
            "doneText": "Ihr Mailserver ist aktiv. Mails an Ihre Kunden kommen ab jetzt von {{sender}}.",
            "doneCheck": "Wir prüfen ihn jede Nacht. Klappt das einmal nicht, sehen Sie es hier und im ganzen Cockpit.",
            "dialogDiscardTitle": "Eingaben verwerfen?",
            "dialogDiscardMessage": "Ihre Eingaben sind noch nicht gespeichert und gehen beim Schließen verloren.",
            "dialogKeepEditing": "Weiter bearbeiten",
            "showTechnicalDetails": "Technische Details anzeigen",
            "hideTechnicalDetails": "Technische Details ausblenden",
            "transport": "Versandart",
            "transportSmtp": "Eigener SMTP-Server",
            "transportOffice365": "Microsoft 365",
            "tenantId": "Verzeichnis-ID (Mandant)",
            "clientId": "Anwendungs-ID (Client)",
            "clientSecret": "Clientschlüssel",
            "clientSecretHint": "Der Wert des Schlüssels, nicht dessen Geheimnis-ID",
            "secretUnchanged": "Gespeichert – zum Ändern neu eintragen",
            "mailbox": "Postfach",
            "senderNameFromExchange": "Den Absendernamen setzt Microsoft 365 selbst.",
            "office365Intro": "Die Werte stammen aus einer App-Registrierung in Ihrem Microsoft-Entra-Verzeichnis.",
            "correctSettings": "Einstellungen korrigieren",
            "statusReasonMailTooLarge": "Die Mail war zu groß für den Versand.",
            "statusReasonSecretExpired": "Der Clientschlüssel ist abgelaufen. Legen Sie in Microsoft Entra einen neuen an und tragen Sie ihn hier ein.",
            "statusReasonSecretInvalid": "Der Clientschlüssel wird nicht akzeptiert. Tragen Sie den Wert des Schlüssels ein, nicht dessen Geheimnis-ID.",
            "statusReasonAppNotFound": "Die Anwendungs-ID ist in diesem Verzeichnis unbekannt.",
            "statusReasonTenantNotFound": "Die Verzeichnis-ID ist unbekannt.",
            "statusReasonAccessDenied": "Die Anwendung darf aus diesem Postfach nicht senden. Prüfen Sie die Freigabe in Microsoft 365.",
            "statusReasonMailboxNotFound": "Das Postfach wurde nicht gefunden.",
            "rejectedNeedsHost": "Bitte tragen Sie den Server ein.",
            "rejectedNeedsPort": "Bitte tragen Sie den Port ein.",
            "rejectedNeedsTenantId": "Bitte tragen Sie die Verzeichnis-ID ein.",
            "rejectedInvalidTenantId": "Die Verzeichnis-ID muss eine GUID oder eine verifizierte Domain sein.",
            "rejectedNeedsClientId": "Bitte tragen Sie die Anwendungs-ID ein.",
            "rejectedNeedsClientSecret": "Bitte tragen Sie den Clientschlüssel ein.",
            "office365Offer": "Versenden Sie über das Microsoft 365 Ihres Betriebs."
        }
    },
    "priceBook": {
        "title": "Preisliste",
        "overview": {
            "title": "Preislisten",
            "description": "Alle Preislisten der Vertragsverwaltung mit ihren Staffeln, darunter die gemeinsamen Hardware- und Einmalpreise. Änderungen gelten für neue Angebote; bereits berechnete Angebote und Verträge behalten ihre Preise.",
            "noTiers": "Für diese Preisliste sind keine Staffeln hinterlegt.",
            "edit": "Preisliste bearbeiten"
        },
        "locations": "Standorte",
        "notFound": "Diese Preisliste wurde nicht gefunden.",
        "saveSuccess": "Die Preise wurden gespeichert.",
        "saveError": "Die Preise konnten nicht gespeichert werden.",
        "groups": {
            "tariff": "Tarif je Standort / Monat (€)",
            "modules": "Zusatzmodule je Standort / Monat (€)",
            "setup": "Einrichtung je Standort / einmalig (€)"
        },
        "fees": {
            "basisFee": "Basis",
            "standardFee": "Standard",
            "premiumFee": "Shop",
            "additionalBrandFee": "Marken­aufschlag",
            "vehicleExchangeModuleFee": "Fahrzeug­börse",
            "groupModuleFee": "Gruppen­modul",
            "basisSetupCost": "Basis",
            "standardSetupCost": "Standard",
            "premiumSetupCost": "Shop"
        },
        "setupFees": {
            "title": "Hardware- und Einmalpreise",
            "tablet": "Tablet",
            "tabletTerminal": "Halter für Tablet",
            "qrHanger": "QR Spiegelanhänger",
            "qrCodes": "QR Magnetfolien (Set)",
            "qrStickerRoll": "QR Sticker Rolle",
            "edit": "Preise bearbeiten"
        },
        "addBand": "Staffel hinzufügen",
        "removeBand": "Staffel entfernen",
        "minLocations": "Standorte von",
        "maxLocations": "Standorte bis",
        "issues": {
            "label": "Hinweis zur Staffel",
            "summary": "Es gibt Lücken und/oder Überlappungen in der Standortdefinition. Betroffene Zeilen sind markiert; gespeichert werden kann trotzdem.",
            "inverted": "Der obere Wert liegt unter dem unteren.",
            "overlap": "Überlappt sich mit der vorhergehenden Staffel.",
            "gap": "Lücke zur vorhergehenden Staffel — für die dazwischenliegenden Standortzahlen gibt es keinen Preis.",
            "activeWithoutBands": "Diese Preisliste ist aktiv, enthält aber keine Staffeln. Sie steht damit bei der Angebotsrechnung zur Auswahl, die Berechnung schlägt dort aber fehl. Legen Sie Staffeln an oder deaktivieren Sie die Preisliste."
        },
        "displayName": "Anzeigename",
        "internalName": "Interner Name",
        "internalNameHint": "Schlüssel der Preisberechnung, muss eindeutig sein.",
        "properties": "Eigenschaften",
        "active": "Preisliste ist aktiv",
        "activeHint": "Inaktive Preislisten stehen bei der Angebotsrechnung nicht mehr zur Auswahl. Bestehende Angebote und Verträge bleiben davon unberührt.",
        "inactive": "inaktiv",
        "create": {
            "title": "Neue Preisliste anlegen",
            "submit": "Preisliste anlegen",
            "copyFrom": "Staffeln übernehmen von",
            "copyFromHint": "Optional. Die Staffeln der gewählten Preisliste werden kopiert und können danach angepasst werden.",
            "noTemplate": "Ohne Vorlage — leer beginnen",
            "success": "Die Preisliste wurde angelegt.",
            "error": "Die Preisliste konnte nicht angelegt werden."
        },
        "delete": {
            "title": "Preisliste löschen",
            "submit": "Preisliste löschen",
            "confirm": "Soll die Preisliste „{{label}}“ endgültig gelöscht werden? Ihre Staffeln werden mitgelöscht. Das lässt sich nicht rückgängig machen.",
            "success": "Die Preisliste wurde gelöscht.",
            "inUse": "Diese Preisliste wurde bereits für Angebote verwendet und kann deshalb nicht gelöscht werden. Deaktivieren Sie sie stattdessen.",
            "error": "Die Preisliste konnte nicht gelöscht werden."
        }
    },
    "supportContext": {
        "searchLabel": "Im Kontext arbeiten",
        "searchPlaceholder": "Autohaus oder Gruppe suchen",
        "garage": "Autohaus",
        "group": "Gruppe",
        "noOptions": "Keine Treffer",
        "loading": "Suche läuft …",
        "banner": "Sie arbeiten im Kontext von {{type}} „{{label}}“.",
        "bannerHint": "Sie sehen das Cockpit aus Sicht des Kunden, mit Ihren eigenen Rechten. Verträge sind gesperrt, AVV und Mail-Versand sind nur lesbar; Zugriffe auf Bestellungen werden protokolliert.",
        "end": "Beenden",
        "orderAccess": {
            "title": "Zugriff auf Bestellungen",
            "text": "Bestellungen enthalten Kundendaten von „{{label}}“. Ihr Zugriff wird mit Ihrem Nutzerkonto protokolliert. Öffnen Sie Bestellungen nur, wenn eine Support-Anfrage es erfordert.",
            "confirm": "Zugriff protokollieren und öffnen"
        }
    },
    "garageGroupList": {
        "menu": "Gruppen",
        "title": "Gruppen",
        "search": "Name oder Kundennummer",
        "customerNumber": "Kunden-Nr.",
        "name": "Gruppe",
        "empty": "Keine Gruppen gefunden"
    },
    "supportStart": {
        "menu": "Start",
        "title": "Support-Start",
        "search": {
            "title": "Im Kontext eines Kunden arbeiten",
            "description": "Suchen Sie nach Name oder Kundennummer eines Autohauses oder einer Gruppe. Bei einem Autohaus wird auch dessen Gruppe vorgeschlagen."
        },
        "recent": {
            "title": "Zuletzt genutzt",
            "empty": "Hier erscheinen die Autohäuser und Gruppen, in deren Kontext Sie zuletzt gearbeitet haben."
        },
        "quickAccess": {
            "title": "Schnellzugriffe"
        },
        "howItWorks": {
            "title": "So funktioniert der Kontext",
            "view": "Sie sehen das Cockpit aus Sicht des Kunden – mit Ihren eigenen Rechten, ohne sich als Kunde anzumelden.",
            "write": "Produkte und Preise, Stammdaten, Nutzer, Rabattcodes und Mailer können Sie bearbeiten; jede Änderung wird mit Ihrem Nutzerkonto protokolliert.",
            "blocked": "Verträge, das Unterschreiben der AVV, der Mailserver, Anfragen ans Hilfe-Center und Ihr eigenes Konto sind im Kontext gesperrt. Bestellungen bearbeiten Sie wie das Autohaus; jeder Zugriff darauf wird protokolliert.",
            "end": "Der Kontext gilt nur in diesem Tab und endet mit „Beenden“ im gelben Banner oder beim Abmelden."
        }
    }
}
